const state = {
  produkte: {
    Beilage: {
      "Rota 42.5g": {
        type: "paged",
        bild: "produkt-beilage.png",
        kategoriename: "Beilage",
        verarbeitung: "beilagen",
        druckkosten: "seiten-gewicht-gestaffelt",
        minmenge: 5000,
        items: [
          {
            seiten: 12,
            gewicht: 17,
            preise: [
              {
                menge: 2500,
                grundpreis: 1532.57,
                weiteretausend: 44.45,
              },
              {
                menge: 5000,
                grundpreis: 1577.05,
                weiteretausend: 44.45,
              },
              {
                menge: 10000,
                grundpreis: 1799.29,
                weiteretausend: 44.45,
              },
              {
                menge: 20000,
                grundpreis: 2243.76,
                weiteretausend: 44.45,
              },
              {
                menge: 30000,
                grundpreis: 2688.24,
                weiteretausend: 44.45,
              },
              {
                menge: 40000,
                grundpreis: 3132.71,
                weiteretausend: 44.45,
              },
              {
                menge: 50000,
                grundpreis: 3577.17,
                weiteretausend: 44.45,
              },
              {
                menge: 100000,
                grundpreis: 5799.55,
                weiteretausend: 44.45,
              },
              {
                menge: 150000,
                grundpreis: 8021.92,
                weiteretausend: 44.45,
              },
              {
                menge: 200000,
                grundpreis: 10244.28,
                weiteretausend: 44.45,
              },
              {
                menge: 250000,
                grundpreis: 12466.65,
                weiteretausend: 44.45,
              },
              {
                menge: 300000,
                grundpreis: 14689.02,
                weiteretausend: 44.45,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 23,
            preise: [
              {
                menge: 2500,
                grundpreis: 1570.32,
                weiteretausend: 50.29,
              },
              {
                menge: 5000,
                grundpreis: 1627.77,
                weiteretausend: 50.29,
              },
              {
                menge: 10000,
                grundpreis: 1879.22,
                weiteretausend: 50.29,
              },
              {
                menge: 20000,
                grundpreis: 2382.13,
                weiteretausend: 50.29,
              },
              {
                menge: 30000,
                grundpreis: 2885.03,
                weiteretausend: 50.29,
              },
              {
                menge: 40000,
                grundpreis: 3387.94,
                weiteretausend: 50.29,
              },
              {
                menge: 50000,
                grundpreis: 3890.84,
                weiteretausend: 50.29,
              },
              {
                menge: 100000,
                grundpreis: 6405.36,
                weiteretausend: 50.29,
              },
              {
                menge: 150000,
                grundpreis: 8919.88,
                weiteretausend: 50.29,
              },
              {
                menge: 200000,
                grundpreis: 11434.4,
                weiteretausend: 50.29,
              },
              {
                menge: 250000,
                grundpreis: 13948.92,
                weiteretausend: 50.29,
              },
              {
                menge: 300000,
                grundpreis: 16463.44,
                weiteretausend: 50.29,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 29,
            preise: [
              {
                menge: 2500,
                grundpreis: 1858.99,
                weiteretausend: 56.11,
              },
              {
                menge: 5000,
                grundpreis: 1918.43,
                weiteretausend: 56.11,
              },
              {
                menge: 10000,
                grundpreis: 2198.96,
                weiteretausend: 56.11,
              },
              {
                menge: 20000,
                grundpreis: 2760.03,
                weiteretausend: 56.11,
              },
              {
                menge: 30000,
                grundpreis: 3321.09,
                weiteretausend: 56.11,
              },
              {
                menge: 40000,
                grundpreis: 3882.15,
                weiteretausend: 56.11,
              },
              {
                menge: 50000,
                grundpreis: 4443.22,
                weiteretausend: 56.11,
              },
              {
                menge: 100000,
                grundpreis: 7248.53,
                weiteretausend: 56.11,
              },
              {
                menge: 150000,
                grundpreis: 10053.85,
                weiteretausend: 56.11,
              },
              {
                menge: 200000,
                grundpreis: 12859.17,
                weiteretausend: 56.11,
              },
              {
                menge: 250000,
                grundpreis: 15664.48,
                weiteretausend: 56.11,
              },
              {
                menge: 300000,
                grundpreis: 18469.8,
                weiteretausend: 56.11,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 34,
            preise: [
              {
                menge: 2500,
                grundpreis: 1896.61,
                weiteretausend: 61.91,
              },
              {
                menge: 5000,
                grundpreis: 1968.92,
                weiteretausend: 61.91,
              },
              {
                menge: 10000,
                grundpreis: 2278.46,
                weiteretausend: 61.91,
              },
              {
                menge: 20000,
                grundpreis: 2897.56,
                weiteretausend: 61.91,
              },
              {
                menge: 30000,
                grundpreis: 3516.65,
                weiteretausend: 61.91,
              },
              {
                menge: 40000,
                grundpreis: 4135.74,
                weiteretausend: 61.91,
              },
              {
                menge: 50000,
                grundpreis: 4754.83,
                weiteretausend: 61.91,
              },
              {
                menge: 100000,
                grundpreis: 7850.83,
                weiteretausend: 61.91,
              },
              {
                menge: 150000,
                grundpreis: 10945.74,
                weiteretausend: 61.91,
              },
              {
                menge: 200000,
                grundpreis: 14041.19,
                weiteretausend: 61.91,
              },
              {
                menge: 250000,
                grundpreis: 17136.65,
                weiteretausend: 61.91,
              },
              {
                menge: 300000,
                grundpreis: 20232.1,
                weiteretausend: 61.91,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 40,
            preise: [
              {
                menge: 2500,
                grundpreis: 2407.42,
                weiteretausend: 67.77,
              },
              {
                menge: 5000,
                grundpreis: 2472.16,
                weiteretausend: 67.77,
              },
              {
                menge: 10000,
                grundpreis: 2810.99,
                weiteretausend: 67.77,
              },
              {
                menge: 20000,
                grundpreis: 3488.64,
                weiteretausend: 67.77,
              },
              {
                menge: 30000,
                grundpreis: 4166.29,
                weiteretausend: 67.77,
              },
              {
                menge: 40000,
                grundpreis: 4843.95,
                weiteretausend: 67.77,
              },
              {
                menge: 50000,
                grundpreis: 5521.6,
                weiteretausend: 67.77,
              },
              {
                menge: 100000,
                grundpreis: 8908.87,
                weiteretausend: 67.77,
              },
              {
                menge: 150000,
                grundpreis: 12298.14,
                weiteretausend: 67.77,
              },
              {
                menge: 200000,
                grundpreis: 15686.4,
                weiteretausend: 67.77,
              },
              {
                menge: 250000,
                grundpreis: 19074.67,
                weiteretausend: 67.77,
              },
              {
                menge: 300000,
                grundpreis: 22462.94,
                weiteretausend: 67.77,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 46,
            preise: [
              {
                menge: 2500,
                grundpreis: 1972.14,
                weiteretausend: 73.61,
              },
              {
                menge: 5000,
                grundpreis: 2070.41,
                weiteretausend: 73.61,
              },
              {
                menge: 10000,
                grundpreis: 2438.45,
                weiteretausend: 73.61,
              },
              {
                menge: 20000,
                grundpreis: 3174.52,
                weiteretausend: 73.61,
              },
              {
                menge: 30000,
                grundpreis: 3910.59,
                weiteretausend: 73.61,
              },
              {
                menge: 40000,
                grundpreis: 4646.66,
                weiteretausend: 73.61,
              },
              {
                menge: 50000,
                grundpreis: 5382.73,
                weiteretausend: 73.61,
              },
              {
                menge: 100000,
                grundpreis: 9063.08,
                weiteretausend: 73.61,
              },
              {
                menge: 150000,
                grundpreis: 12743.43,
                weiteretausend: 73.61,
              },
              {
                menge: 200000,
                grundpreis: 16423.78,
                weiteretausend: 73.61,
              },
              {
                menge: 250000,
                grundpreis: 20104.13,
                weiteretausend: 73.61,
              },
              {
                menge: 300000,
                grundpreis: 23784.48,
                weiteretausend: 73.61,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 52,
            preise: [
              {
                menge: 2500,
                grundpreis: 2850.26,
                weiteretausend: 87.11,
              },
              {
                menge: 5000,
                grundpreis: 2944.11,
                weiteretausend: 87.11,
              },
              {
                menge: 10000,
                grundpreis: 3379.67,
                weiteretausend: 87.11,
              },
              {
                menge: 20000,
                grundpreis: 4250.77,
                weiteretausend: 87.11,
              },
              {
                menge: 30000,
                grundpreis: 5121.87,
                weiteretausend: 87.11,
              },
              {
                menge: 40000,
                grundpreis: 5992.98,
                weiteretausend: 87.11,
              },
              {
                menge: 50000,
                grundpreis: 6864.08,
                weiteretausend: 87.11,
              },
              {
                menge: 100000,
                grundpreis: 11219.6,
                weiteretausend: 87.11,
              },
              {
                menge: 150000,
                grundpreis: 15575.12,
                weiteretausend: 87.11,
              },
              {
                menge: 200000,
                grundpreis: 19930.63,
                weiteretausend: 87.11,
              },
              {
                menge: 250000,
                grundpreis: 24286.15,
                weiteretausend: 87.11,
              },
              {
                menge: 300000,
                grundpreis: 28641.67,
                weiteretausend: 87.11,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 57,
            preise: [
              {
                menge: 2500,
                grundpreis: 2248.87,
                weiteretausend: 92.86,
              },
              {
                menge: 5000,
                grundpreis: 2383.24,
                weiteretausend: 92.86,
              },
              {
                menge: 10000,
                grundpreis: 2847.55,
                weiteretausend: 92.86,
              },
              {
                menge: 20000,
                grundpreis: 3776.16,
                weiteretausend: 92.86,
              },
              {
                menge: 30000,
                grundpreis: 4704.77,
                weiteretausend: 92.86,
              },
              {
                menge: 40000,
                grundpreis: 5633.38,
                weiteretausend: 92.86,
              },
              {
                menge: 50000,
                grundpreis: 6561.99,
                weiteretausend: 92.86,
              },
              {
                menge: 100000,
                grundpreis: 11205.04,
                weiteretausend: 92.86,
              },
              {
                menge: 150000,
                grundpreis: 15848.09,
                weiteretausend: 92.86,
              },
              {
                menge: 200000,
                grundpreis: 20491.14,
                weiteretausend: 92.86,
              },
              {
                menge: 250000,
                grundpreis: 25134.19,
                weiteretausend: 92.86,
              },
              {
                menge: 300000,
                grundpreis: 29777.24,
                weiteretausend: 92.86,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 63,
            preise: [
              {
                menge: 2500,
                grundpreis: 3284.06,
                weiteretausend: 98.72,
              },
              {
                menge: 5000,
                grundpreis: 3388.07,
                weiteretausend: 98.72,
              },
              {
                menge: 10000,
                grundpreis: 3881.65,
                weiteretausend: 98.72,
              },
              {
                menge: 20000,
                grundpreis: 4868.81,
                weiteretausend: 98.72,
              },
              {
                menge: 30000,
                grundpreis: 5855.98,
                weiteretausend: 98.72,
              },
              {
                menge: 40000,
                grundpreis: 6843.15,
                weiteretausend: 98.72,
              },
              {
                menge: 50000,
                grundpreis: 7830.31,
                weiteretausend: 98.72,
              },
              {
                menge: 100000,
                grundpreis: 12766.14,
                weiteretausend: 98.72,
              },
              {
                menge: 150000,
                grundpreis: 17701.97,
                weiteretausend: 98.72,
              },
              {
                menge: 200000,
                grundpreis: 22637.8,
                weiteretausend: 98.72,
              },
              {
                menge: 250000,
                grundpreis: 27573.63,
                weiteretausend: 98.72,
              },
              {
                menge: 300000,
                grundpreis: 32509.45,
                weiteretausend: 98.72,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 69,
            preise: [
              {
                menge: 2500,
                grundpreis: 2369.18,
                weiteretausend: 104.61,
              },
              {
                menge: 5000,
                grundpreis: 2527.7,
                weiteretausend: 104.61,
              },
              {
                menge: 10000,
                grundpreis: 3050.76,
                weiteretausend: 104.61,
              },
              {
                menge: 20000,
                grundpreis: 4096.88,
                weiteretausend: 104.61,
              },
              {
                menge: 30000,
                grundpreis: 5143.0,
                weiteretausend: 104.61,
              },
              {
                menge: 40000,
                grundpreis: 6189.12,
                weiteretausend: 104.61,
              },
              {
                menge: 50000,
                grundpreis: 7235.23,
                weiteretausend: 104.61,
              },
              {
                menge: 100000,
                grundpreis: 12465.82,
                weiteretausend: 104.61,
              },
              {
                menge: 150000,
                grundpreis: 17696.41,
                weiteretausend: 104.61,
              },
              {
                menge: 200000,
                grundpreis: 22926.99,
                weiteretausend: 104.61,
              },
              {
                menge: 250000,
                grundpreis: 28157.58,
                weiteretausend: 104.61,
              },
              {
                menge: 300000,
                grundpreis: 33388.16,
                weiteretausend: 104.61,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 80,
            preise: [
              {
                menge: 2500,
                grundpreis: 2584.67,
                weiteretausend: 135.58,
              },
              {
                menge: 5000,
                grundpreis: 2811.25,
                weiteretausend: 135.58,
              },
              {
                menge: 10000,
                grundpreis: 3489.16,
                weiteretausend: 135.58,
              },
              {
                menge: 20000,
                grundpreis: 4844.99,
                weiteretausend: 135.58,
              },
              {
                menge: 30000,
                grundpreis: 6200.82,
                weiteretausend: 135.58,
              },
              {
                menge: 40000,
                grundpreis: 7556.64,
                weiteretausend: 135.58,
              },
              {
                menge: 50000,
                grundpreis: 8912.47,
                weiteretausend: 135.58,
              },
              {
                menge: 100000,
                grundpreis: 15691.61,
                weiteretausend: 135.58,
              },
              {
                menge: 150000,
                grundpreis: 22470.75,
                weiteretausend: 135.58,
              },
              {
                menge: 200000,
                grundpreis: 29249.89,
                weiteretausend: 135.58,
              },
              {
                menge: 250000,
                grundpreis: 36029.03,
                weiteretausend: 135.58,
              },
              {
                menge: 300000,
                grundpreis: 42808.17,
                weiteretausend: 135.58,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 92,
            preise: [
              {
                menge: 2500,
                grundpreis: 2772.25,
                weiteretausend: 147.33,
              },
              {
                menge: 5000,
                grundpreis: 3020.05,
                weiteretausend: 147.33,
              },
              {
                menge: 10000,
                grundpreis: 3756.73,
                weiteretausend: 147.33,
              },
              {
                menge: 20000,
                grundpreis: 5230.07,
                weiteretausend: 147.33,
              },
              {
                menge: 30000,
                grundpreis: 6703.41,
                weiteretausend: 147.33,
              },
              {
                menge: 40000,
                grundpreis: 8176.75,
                weiteretausend: 147.33,
              },
              {
                menge: 50000,
                grundpreis: 9650.09,
                weiteretausend: 147.33,
              },
              {
                menge: 100000,
                grundpreis: 17016.8,
                weiteretausend: 147.33,
              },
              {
                menge: 150000,
                grundpreis: 24383.52,
                weiteretausend: 147.33,
              },
              {
                menge: 200000,
                grundpreis: 31750.23,
                weiteretausend: 147.33,
              },
              {
                menge: 250000,
                grundpreis: 39116.94,
                weiteretausend: 147.33,
              },
              {
                menge: 30000,
                grundpreis: 46483.65,
                weiteretausend: 147.33,
              },
            ],
          },
        ],
      },
      "Rota 52g": {
        type: "paged",
        bild: "produkt-beilage.png",
        kategoriename: "Beilage",
        verarbeitung: "beilagen",
        druckkosten: "seiten-gewicht-gestaffelt",
        minmenge: 5000,
        items: [
          {
            seiten: 8,
            gewicht: 14,
            preise: [
              {
                menge: 2500,
                grundpreis: 1501.97,
                weiteretausend: 41.33,
              },
              {
                menge: 5000,
                grundpreis: 1540,
                weiteretausend: 41.33,
              },
              {
                menge: 10000,
                grundpreis: 1746.67,
                weiteretausend: 41.33,
              },
              {
                menge: 20000,
                grundpreis: 2160.01,
                weiteretausend: 41.33,
              },
              {
                menge: 30000,
                grundpreis: 2573.35,
                weiteretausend: 41.33,
              },
              {
                menge: 40000,
                grundpreis: 2986.69,
                weiteretausend: 41.33,
              },
              {
                menge: 50000,
                grundpreis: 3400.03,
                weiteretausend: 41.33,
              },
              {
                menge: 100000,
                grundpreis: 5466.74,
                weiteretausend: 41.33,
              },
              {
                menge: 150000,
                grundpreis: 7533.44,
                weiteretausend: 41.33,
              },
              {
                menge: 200000,
                grundpreis: 9600.14,
                weiteretausend: 41.33,
              },
              {
                menge: 250000,
                grundpreis: 11666.85,
                weiteretausend: 41.33,
              },
              {
                menge: 300000,
                grundpreis: 13733.55,
                weiteretausend: 41.33,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 21,
            preise: [
              {
                menge: 2500,
                grundpreis: 1543.27,
                weiteretausend: 48.54,
              },
              {
                menge: 5000,
                grundpreis: 1597.52,
                weiteretausend: 48.54,
              },
              {
                menge: 10000,
                grundpreis: 1840.23,
                weiteretausend: 48.54,
              },
              {
                menge: 20000,
                grundpreis: 2325.64,
                weiteretausend: 48.54,
              },
              {
                menge: 30000,
                grundpreis: 2811.05,
                weiteretausend: 48.54,
              },
              {
                menge: 40000,
                grundpreis: 3296.46,
                weiteretausend: 48.54,
              },
              {
                menge: 50000,
                grundpreis: 3781.87,
                weiteretausend: 48.54,
              },
              {
                menge: 100000,
                grundpreis: 6208.91,
                weiteretausend: 48.54,
              },
              {
                menge: 150000,
                grundpreis: 8635.96,
                weiteretausend: 48.54,
              },
              {
                menge: 200000,
                grundpreis: 11063.01,
                weiteretausend: 48.54,
              },
              {
                menge: 250000,
                grundpreis: 13490.06,
                weiteretausend: 48.54,
              },
              {
                menge: 300000,
                grundpreis: 15917.11,
                weiteretausend: 48.54,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 28,
            preise: [
              {
                menge: 2500,
                grundpreis: 1584.62,
                weiteretausend: 55.76,
              },
              {
                menge: 5000,
                grundpreis: 1655.13,
                weiteretausend: 55.76,
              },
              {
                menge: 10000,
                grundpreis: 1933.94,
                weiteretausend: 55.76,
              },
              {
                menge: 20000,
                grundpreis: 2491.56,
                weiteretausend: 55.76,
              },
              {
                menge: 30000,
                grundpreis: 3049.17,
                weiteretausend: 55.76,
              },
              {
                menge: 40000,
                grundpreis: 3606.79,
                weiteretausend: 55.76,
              },
              {
                menge: 50000,
                grundpreis: 4164.41,
                weiteretausend: 55.76,
              },
              {
                menge: 100000,
                grundpreis: 6952.5,
                weiteretausend: 55.76,
              },
              {
                menge: 150000,
                grundpreis: 9740.58,
                weiteretausend: 55.76,
              },
              {
                menge: 200000,
                grundpreis: 12528.67,
                weiteretausend: 55.76,
              },
              {
                menge: 250000,
                grundpreis: 15316.76,
                weiteretausend: 55.76,
              },
              {
                menge: 300000,
                grundpreis: 18104.85,
                weiteretausend: 55.76,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 35,
            preise: [
              {
                menge: 2500,
                grundpreis: 1876.93,
                weiteretausend: 62.97,
              },
              {
                menge: 5000,
                grundpreis: 1952.74,
                weiteretausend: 62.97,
              },
              {
                menge: 10000,
                grundpreis: 2267.59,
                weiteretausend: 62.97,
              },
              {
                menge: 20000,
                grundpreis: 2897.27,
                weiteretausend: 62.97,
              },
              {
                menge: 30000,
                grundpreis: 3526.96,
                weiteretausend: 62.97,
              },
              {
                menge: 40000,
                grundpreis: 4156.64,
                weiteretausend: 62.97,
              },
              {
                menge: 50000,
                grundpreis: 4786.33,
                weiteretausend: 62.97,
              },
              {
                menge: 100000,
                grundpreis: 7934.76,
                weiteretausend: 62.97,
              },
              {
                menge: 150000,
                grundpreis: 11083.2,
                weiteretausend: 62.97,
              },
              {
                menge: 200000,
                grundpreis: 14231.63,
                weiteretausend: 62.97,
              },
              {
                menge: 250000,
                grundpreis: 17380.06,
                weiteretausend: 62.97,
              },
              {
                menge: 300000,
                grundpreis: 20528.5,
                weiteretausend: 62.97,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 42,
            preise: [
              {
                menge: 2500,
                grundpreis: 1918.21,
                weiteretausend: 70.18,
              },
              {
                menge: 5000,
                grundpreis: 2010.25,
                weiteretausend: 70.18,
              },
              {
                menge: 10000,
                grundpreis: 2361.13,
                weiteretausend: 70.18,
              },
              {
                menge: 20000,
                grundpreis: 3062.88,
                weiteretausend: 70.18,
              },
              {
                menge: 30000,
                grundpreis: 3764.64,
                weiteretausend: 70.18,
              },
              {
                menge: 40000,
                grundpreis: 4466.4,
                weiteretausend: 70.18,
              },
              {
                menge: 50000,
                grundpreis: 5168.15,
                weiteretausend: 70.18,
              },
              {
                menge: 100000,
                grundpreis: 8676.93,
                weiteretausend: 70.18,
              },
              {
                menge: 150000,
                grundpreis: 12185.71,
                weiteretausend: 70.18,
              },
              {
                menge: 200000,
                grundpreis: 15694.48,
                weiteretausend: 70.18,
              },
              {
                menge: 250000,
                grundpreis: 19203.26,
                weiteretausend: 70.18,
              },
              {
                menge: 300000,
                grundpreis: 22712.04,
                weiteretausend: 70.18,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 49,
            preise: [
              {
                menge: 2500,
                grundpreis: 2432.59,
                weiteretausend: 77.4,
              },
              {
                menge: 5000,
                grundpreis: 2520.31,
                weiteretausend: 77.4,
              },
              {
                menge: 10000,
                grundpreis: 2907.3,
                weiteretausend: 77.4,
              },
              {
                menge: 20000,
                grundpreis: 3681.26,
                weiteretausend: 77.4,
              },
              {
                menge: 30000,
                grundpreis: 4455.22,
                weiteretausend: 77.4,
              },
              {
                menge: 40000,
                grundpreis: 5229.19,
                weiteretausend: 77.4,
              },
              {
                menge: 50000,
                grundpreis: 6003.15,
                weiteretausend: 77.4,
              },
              {
                menge: 100000,
                grundpreis: 9872.97,
                weiteretausend: 77.4,
              },
              {
                menge: 150000,
                grundpreis: 13742.78,
                weiteretausend: 77.4,
              },
              {
                menge: 200000,
                grundpreis: 17612.6,
                weiteretausend: 77.4,
              },
              {
                menge: 250000,
                grundpreis: 21482.42,
                weiteretausend: 77.4,
              },
              {
                menge: 300000,
                grundpreis: 25352.24,
                weiteretausend: 77.4,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 56,
            preise: [
              {
                menge: 2500,
                grundpreis: 2000.85,
                weiteretausend: 84.59,
              },
              {
                menge: 5000,
                grundpreis: 2125.33,
                weiteretausend: 84.59,
              },
              {
                menge: 10000,
                grundpreis: 2548.27,
                weiteretausend: 84.59,
              },
              {
                menge: 20000,
                grundpreis: 3394.17,
                weiteretausend: 84.59,
              },
              {
                menge: 30000,
                grundpreis: 4240.06,
                weiteretausend: 84.59,
              },
              {
                menge: 40000,
                grundpreis: 5085.95,
                weiteretausend: 84.59,
              },
              {
                menge: 50000,
                grundpreis: 5931.85,
                weiteretausend: 84.59,
              },
              {
                menge: 100000,
                grundpreis: 10161.31,
                weiteretausend: 84.59,
              },
              {
                menge: 150000,
                grundpreis: 14390.78,
                weiteretausend: 84.59,
              },
              {
                menge: 200000,
                grundpreis: 18620.25,
                weiteretausend: 84.59,
              },
              {
                menge: 250000,
                grundpreis: 22849.71,
                weiteretausend: 84.59,
              },
              {
                menge: 300000,
                grundpreis: 27079.18,
                weiteretausend: 84.59,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 63,
            preise: [
              {
                menge: 2500,
                grundpreis: 2882.5,
                weiteretausend: 99.44,
              },
              {
                menge: 5000,
                grundpreis: 3005.78,
                weiteretausend: 99.44,
              },
              {
                menge: 10000,
                grundpreis: 3503.0,
                weiteretausend: 99.44,
              },
              {
                menge: 20000,
                grundpreis: 4497.44,
                weiteretausend: 99.44,
              },
              {
                menge: 30000,
                grundpreis: 5491.88,
                weiteretausend: 99.44,
              },
              {
                menge: 40000,
                grundpreis: 6486.32,
                weiteretausend: 99.44,
              },
              {
                menge: 50000,
                grundpreis: 7480.76,
                weiteretausend: 99.44,
              },
              {
                menge: 100000,
                grundpreis: 12452.97,
                weiteretausend: 99.44,
              },
              {
                menge: 150000,
                grundpreis: 17425.17,
                weiteretausend: 99.44,
              },
              {
                menge: 200000,
                grundpreis: 22397.37,
                weiteretausend: 99.44,
              },
              {
                menge: 250000,
                grundpreis: 27369.57,
                weiteretausend: 99.44,
              },
              {
                menge: 300000,
                grundpreis: 32341.77,
                weiteretausend: 99.44,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 70,
            preise: [
              {
                menge: 2500,
                grundpreis: 2284.95,
                weiteretausend: 106.66,
              },
              {
                menge: 5000,
                grundpreis: 2452.26,
                weiteretausend: 106.66,
              },
              {
                menge: 10000,
                grundpreis: 2985.59,
                weiteretausend: 106.66,
              },
              {
                menge: 20000,
                grundpreis: 4052.23,
                weiteretausend: 106.66,
              },
              {
                menge: 30000,
                grundpreis: 5118.88,
                weiteretausend: 106.66,
              },
              {
                menge: 40000,
                grundpreis: 6185.53,
                weiteretausend: 106.66,
              },
              {
                menge: 50000,
                grundpreis: 7252.18,
                weiteretausend: 106.66,
              },
              {
                menge: 100000,
                grundpreis: 12585.42,
                weiteretausend: 106.66,
              },
              {
                menge: 150000,
                grundpreis: 17918.66,
                weiteretausend: 106.66,
              },
              {
                menge: 200000,
                grundpreis: 23251.91,
                weiteretausend: 106.66,
              },
              {
                menge: 250000,
                grundpreis: 28585.15,
                weiteretausend: 106.66,
              },
              {
                menge: 300000,
                grundpreis: 33918.39,
                weiteretausend: 106.66,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 77,
            preise: [
              {
                menge: 2500,
                grundpreis: 3323.67,
                weiteretausend: 113.87,
              },
              {
                menge: 5000,
                grundpreis: 3463.84,
                weiteretausend: 113.87,
              },
              {
                menge: 10000,
                grundpreis: 4033.2,
                weiteretausend: 113.87,
              },
              {
                menge: 20000,
                grundpreis: 5171.92,
                weiteretausend: 113.87,
              },
              {
                menge: 30000,
                grundpreis: 6310.63,
                weiteretausend: 113.87,
              },
              {
                menge: 40000,
                grundpreis: 7449.35,
                weiteretausend: 113.87,
              },
              {
                menge: 50000,
                grundpreis: 8588.07,
                weiteretausend: 113.87,
              },
              {
                menge: 100000,
                grundpreis: 14281.66,
                weiteretausend: 113.87,
              },
              {
                menge: 150000,
                grundpreis: 19975.24,
                weiteretausend: 113.87,
              },
              {
                menge: 200000,
                grundpreis: 25668.83,
                weiteretausend: 113.87,
              },
              {
                menge: 250000,
                grundpreis: 31362.42,
                weiteretausend: 113.87,
              },
              {
                menge: 300000,
                grundpreis: 37056.0,
                weiteretausend: 113.87,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 84,
            preise: [
              {
                menge: 2500,
                grundpreis: 2412.22,
                weiteretausend: 121.08,
              },
              {
                menge: 5000,
                grundpreis: 2610.04,
                weiteretausend: 121.08,
              },
              {
                menge: 10000,
                grundpreis: 3215.43,
                weiteretausend: 121.08,
              },
              {
                menge: 20000,
                grundpreis: 4426.22,
                weiteretausend: 121.08,
              },
              {
                menge: 30000,
                grundpreis: 5637.01,
                weiteretausend: 121.08,
              },
              {
                menge: 40000,
                grundpreis: 6847.79,
                weiteretausend: 121.08,
              },
              {
                menge: 50000,
                grundpreis: 8058.58,
                weiteretausend: 121.08,
              },
              {
                menge: 100000,
                grundpreis: 14112.51,
                weiteretausend: 121.08,
              },
              {
                menge: 150000,
                grundpreis: 20166.44,
                weiteretausend: 121.08,
              },
              {
                menge: 200000,
                grundpreis: 26220.37,
                weiteretausend: 121.08,
              },
              {
                menge: 250000,
                grundpreis: 32274.3,
                weiteretausend: 121.08,
              },
              {
                menge: 300000,
                grundpreis: 38328.24,
                weiteretausend: 121.08,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 98,
            preise: [
              {
                menge: 2500,
                grundpreis: 2634.84,
                weiteretausend: 154.78,
              },
              {
                menge: 5000,
                grundpreis: 2907.23,
                weiteretausend: 154.78,
              },
              {
                menge: 10000,
                grundpreis: 3681.12,
                weiteretausend: 154.78,
              },
              {
                menge: 20000,
                grundpreis: 5228.91,
                weiteretausend: 154.78,
              },
              {
                menge: 30000,
                grundpreis: 6776.7,
                weiteretausend: 154.78,
              },
              {
                menge: 40000,
                grundpreis: 8324.48,
                weiteretausend: 154.78,
              },
              {
                menge: 50000,
                grundpreis: 9872.27,
                weiteretausend: 154.78,
              },
              {
                menge: 100000,
                grundpreis: 17611.21,
                weiteretausend: 154.78,
              },
              {
                menge: 150000,
                grundpreis: 25350.15,
                weiteretausend: 154.78,
              },
              {
                menge: 200000,
                grundpreis: 33089.09,
                weiteretausend: 154.78,
              },
              {
                menge: 250000,
                grundpreis: 40828.03,
                weiteretausend: 154.78,
              },
              {
                menge: 300000,
                grundpreis: 48566.97,
                weiteretausend: 154.78,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 112,
            preise: [
              {
                menge: 2500,
                grundpreis: 2829.42,
                weiteretausend: 169.21,
              },
              {
                menge: 5000,
                grundpreis: 3129.42,
                weiteretausend: 169.21,
              },
              {
                menge: 10000,
                grundpreis: 3975.45,
                weiteretausend: 169.21,
              },
              {
                menge: 20000,
                grundpreis: 5667.51,
                weiteretausend: 169.21,
              },
              {
                menge: 30000,
                grundpreis: 7359.58,
                weiteretausend: 169.21,
              },
              {
                menge: 40000,
                grundpreis: 9051.64,
                weiteretausend: 169.21,
              },
              {
                menge: 50000,
                grundpreis: 10743.71,
                weiteretausend: 169.21,
              },
              {
                menge: 100000,
                grundpreis: 19204.03,
                weiteretausend: 169.21,
              },
              {
                menge: 150000,
                grundpreis: 27664.36,
                weiteretausend: 169.21,
              },
              {
                menge: 200000,
                grundpreis: 36124.68,
                weiteretausend: 169.21,
              },
              {
                menge: 250000,
                grundpreis: 44585.01,
                weiteretausend: 169.21,
              },
              {
                menge: 300000,
                grundpreis: 53045.33,
                weiteretausend: 169.21,
              },
            ],
          },
        ],
      },
      "Rota 55g": {
        type: "paged",
        bild: "produkt-beilage.png",
        kategoriename: "Beilage",
        verarbeitung: "beilagen",
        druckkosten: "seiten-gewicht-gestaffelt",
        minmenge: 5000,
        items: [
          {
            seiten: 8,
            gewicht: 15,
            preise: [
              {
                menge: 2500,
                grundpreis: 1503.08,
                weiteretausend: 41.76,
              },
              {
                menge: 5000,
                grundpreis: 1542.12,
                weiteretausend: 41.76,
              },
              {
                menge: 10000,
                grundpreis: 1750.91,
                weiteretausend: 41.76,
              },
              {
                menge: 20000,
                grundpreis: 2168.5,
                weiteretausend: 41.76,
              },
              {
                menge: 30000,
                grundpreis: 2586.08,
                weiteretausend: 41.76,
              },
              {
                menge: 40000,
                grundpreis: 3003.66,
                weiteretausend: 41.76,
              },
              {
                menge: 50000,
                grundpreis: 3421.25,
                weiteretausend: 41.76,
              },
              {
                menge: 100000,
                grundpreis: 5509.17,
                weiteretausend: 41.76,
              },
              {
                menge: 150000,
                grundpreis: 7597.09,
                weiteretausend: 41.76,
              },
              {
                menge: 200000,
                grundpreis: 9685.0,
                weiteretausend: 41.76,
              },
              {
                menge: 250000,
                grundpreis: 11772.92,
                weiteretausend: 41.76,
              },
              {
                menge: 300000,
                grundpreis: 13860.84,
                weiteretausend: 41.76,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 22,
            preise: [
              {
                menge: 2500,
                grundpreis: 1544.93,
                weiteretausend: 49.18,
              },
              {
                menge: 5000,
                grundpreis: 1600.7,
                weiteretausend: 49.18,
              },
              {
                menge: 10000,
                grundpreis: 1846.59,
                weiteretausend: 49.18,
              },
              {
                menge: 20000,
                grundpreis: 2338.37,
                weiteretausend: 49.18,
              },
              {
                menge: 30000,
                grundpreis: 2830.14,
                weiteretausend: 49.18,
              },
              {
                menge: 40000,
                grundpreis: 3321.91,
                weiteretausend: 49.18,
              },
              {
                menge: 50000,
                grundpreis: 3813.69,
                weiteretausend: 49.18,
              },
              {
                menge: 100000,
                grundpreis: 6272.56,
                weiteretausend: 49.18,
              },
              {
                menge: 150000,
                grundpreis: 8731.43,
                weiteretausend: 49.18,
              },
              {
                menge: 200000,
                grundpreis: 11190.3,
                weiteretausend: 49.18,
              },
              {
                menge: 250000,
                grundpreis: 13649.18,
                weiteretausend: 49.18,
              },
              {
                menge: 300000,
                grundpreis: 16108.05,
                weiteretausend: 49.18,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 30,
            preise: [
              {
                menge: 2500,
                grundpreis: 1586.84,
                weiteretausend: 56.61,
              },
              {
                menge: 5000,
                grundpreis: 1659.37,
                weiteretausend: 56.61,
              },
              {
                menge: 10000,
                grundpreis: 1942.42,
                weiteretausend: 56.61,
              },
              {
                menge: 20000,
                grundpreis: 2508.53,
                weiteretausend: 56.61,
              },
              {
                menge: 30000,
                grundpreis: 3074.63,
                weiteretausend: 56.61,
              },
              {
                menge: 40000,
                grundpreis: 3640.74,
                weiteretausend: 56.61,
              },
              {
                menge: 50000,
                grundpreis: 4206.84,
                weiteretausend: 56.61,
              },
              {
                menge: 100000,
                grundpreis: 7037.36,
                weiteretausend: 56.61,
              },
              {
                menge: 150000,
                grundpreis: 9867.88,
                weiteretausend: 56.61,
              },
              {
                menge: 200000,
                grundpreis: 12698.4,
                weiteretausend: 56.61,
              },
              {
                menge: 250000,
                grundpreis: 15528.92,
                weiteretausend: 56.61,
              },
              {
                menge: 300000,
                grundpreis: 18359.44,
                weiteretausend: 56.61,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 37,
            preise: [
              {
                menge: 2500,
                grundpreis: 1879.7,
                weiteretausend: 64.03,
              },
              {
                menge: 5000,
                grundpreis: 1958.05,
                weiteretausend: 64.03,
              },
              {
                menge: 10000,
                grundpreis: 2279.19,
                weiteretausend: 64.03,
              },
              {
                menge: 20000,
                grundpreis: 2918.49,
                weiteretausend: 64.03,
              },
              {
                menge: 30000,
                grundpreis: 3558.78,
                weiteretausend: 64.03,
              },
              {
                menge: 40000,
                grundpreis: 4199.08,
                weiteretausend: 64.03,
              },
              {
                menge: 50000,
                grundpreis: 4839.37,
                weiteretausend: 64.03,
              },
              {
                menge: 100000,
                grundpreis: 8040.84,
                weiteretausend: 64.03,
              },
              {
                menge: 150000,
                grundpreis: 11232.32,
                weiteretausend: 64.03,
              },
              {
                menge: 200000,
                grundpreis: 14443.79,
                weiteretausend: 64.03,
              },
              {
                menge: 250000,
                grundpreis: 17654.26,
                weiteretausend: 64.03,
              },
              {
                menge: 300000,
                grundpreis: 20846.73,
                weiteretausend: 64.03,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 45,
            preise: [
              {
                menge: 2500,
                grundpreis: 1921.54,
                weiteretausend: 71.45,
              },
              {
                menge: 5000,
                grundpreis: 2016.62,
                weiteretausend: 71.45,
              },
              {
                menge: 10000,
                grundpreis: 2373.86,
                weiteretausend: 71.45,
              },
              {
                menge: 20000,
                grundpreis: 3088.34,
                weiteretausend: 71.45,
              },
              {
                menge: 30000,
                grundpreis: 3802.83,
                weiteretausend: 71.45,
              },
              {
                menge: 40000,
                grundpreis: 4517.31,
                weiteretausend: 71.45,
              },
              {
                menge: 50000,
                grundpreis: 5231.8,
                weiteretausend: 71.45,
              },
              {
                menge: 100000,
                grundpreis: 8804.22,
                weiteretausend: 71.45,
              },
              {
                menge: 150000,
                grundpreis: 12376.65,
                weiteretausend: 71.45,
              },
              {
                menge: 200000,
                grundpreis: 15949.07,
                weiteretausend: 71.45,
              },
              {
                menge: 250000,
                grundpreis: 19521.5,
                weiteretausend: 71.45,
              },
              {
                menge: 300000,
                grundpreis: 23093.92,
                weiteretausend: 71.45,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 52,
            preise: [
              {
                menge: 2500,
                grundpreis: 2436.47,
                weiteretausend: 78.88,
              },
              {
                menge: 5000,
                grundpreis: 2527.74,
                weiteretausend: 78.88,
              },
              {
                menge: 10000,
                grundpreis: 2992.15,
                weiteretausend: 78.88,
              },
              {
                menge: 20000,
                grundpreis: 3710.96,
                weiteretausend: 78.88,
              },
              {
                menge: 30000,
                grundpreis: 4499.78,
                weiteretausend: 78.88,
              },
              {
                menge: 40000,
                grundpreis: 5288.59,
                weiteretausend: 78.88,
              },
              {
                menge: 50000,
                grundpreis: 6077.4,
                weiteretausend: 78.88,
              },
              {
                menge: 100000,
                grundpreis: 10021.48,
                weiteretausend: 78.88,
              },
              {
                menge: 150000,
                grundpreis: 13965.55,
                weiteretausend: 78.88,
              },
              {
                menge: 200000,
                grundpreis: 17909.62,
                weiteretausend: 78.88,
              },
              {
                menge: 250000,
                grundpreis: 21853.69,
                weiteretausend: 78.88,
              },
              {
                menge: 300000,
                grundpreis: 25797.77,
                weiteretausend: 78.88,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 59,
            preise: [
              {
                menge: 2500,
                grundpreis: 2005.28,
                weiteretausend: 86.29,
              },
              {
                menge: 5000,
                grundpreis: 2133.81,
                weiteretausend: 86.29,
              },
              {
                menge: 10000,
                grundpreis: 2565.24,
                weiteretausend: 86.29,
              },
              {
                menge: 20000,
                grundpreis: 3428.11,
                weiteretausend: 86.29,
              },
              {
                menge: 30000,
                grundpreis: 4290.98,
                weiteretausend: 86.29,
              },
              {
                menge: 40000,
                grundpreis: 5153.84,
                weiteretausend: 86.29,
              },
              {
                menge: 50000,
                grundpreis: 6016.71,
                weiteretausend: 86.29,
              },
              {
                menge: 100000,
                grundpreis: 10331.04,
                weiteretausend: 86.29,
              },
              {
                menge: 150000,
                grundpreis: 14645.37,
                weiteretausend: 86.29,
              },
              {
                menge: 200000,
                grundpreis: 18959.7,
                weiteretausend: 86.29,
              },
              {
                menge: 250000,
                grundpreis: 23274.03,
                weiteretausend: 86.29,
              },
              {
                menge: 300000,
                grundpreis: 27588.36,
                weiteretausend: 86.29,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 67,
            preise: [
              {
                menge: 2500,
                grundpreis: 2887.49,
                weiteretausend: 101.35,
              },
              {
                menge: 5000,
                grundpreis: 3015.33,
                weiteretausend: 101.35,
              },
              {
                menge: 10000,
                grundpreis: 3522.1,
                weiteretausend: 101.35,
              },
              {
                menge: 20000,
                grundpreis: 4535.63,
                weiteretausend: 101.35,
              },
              {
                menge: 30000,
                grundpreis: 5549.17,
                weiteretausend: 101.35,
              },
              {
                menge: 40000,
                grundpreis: 6562.7,
                weiteretausend: 101.35,
              },
              {
                menge: 50000,
                grundpreis: 7576.24,
                weiteretausend: 101.35,
              },
              {
                menge: 100000,
                grundpreis: 12643.91,
                weiteretausend: 101.35,
              },
              {
                menge: 150000,
                grundpreis: 17711.58,
                weiteretausend: 101.35,
              },
              {
                menge: 200000,
                grundpreis: 22779.25,
                weiteretausend: 101.35,
              },
              {
                menge: 250000,
                grundpreis: 27846.93,
                weiteretausend: 101.35,
              },
              {
                menge: 300000,
                grundpreis: 32914.6,
                weiteretausend: 101.35,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 74,
            preise: [
              {
                menge: 2500,
                grundpreis: 2290.49,
                weiteretausend: 108.79,
              },
              {
                menge: 5000,
                grundpreis: 2462.87,
                weiteretausend: 108.79,
              },
              {
                menge: 10000,
                grundpreis: 3006.8,
                weiteretausend: 108.79,
              },
              {
                menge: 20000,
                grundpreis: 4094.67,
                weiteretausend: 108.79,
              },
              {
                menge: 30000,
                grundpreis: 5182.53,
                weiteretausend: 108.79,
              },
              {
                menge: 40000,
                grundpreis: 6270.39,
                weiteretausend: 108.79,
              },
              {
                menge: 50000,
                grundpreis: 7358.26,
                weiteretausend: 108.79,
              },
              {
                menge: 100000,
                grundpreis: 12797.58,
                weiteretausend: 108.79,
              },
              {
                menge: 150000,
                grundpreis: 18236.9,
                weiteretausend: 108.79,
              },
              {
                menge: 200000,
                grundpreis: 23676.22,
                weiteretausend: 108.79,
              },
              {
                menge: 250000,
                grundpreis: 29115.54,
                weiteretausend: 108.79,
              },
              {
                menge: 300000,
                grundpreis: 34553.86,
                weiteretausend: 108.79,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 82,
            preise: [
              {
                menge: 2500,
                grundpreis: 3329.77,
                weiteretausend: 116.21,
              },
              {
                menge: 5000,
                grundpreis: 3475.51,
                weiteretausend: 116.21,
              },
              {
                menge: 10000,
                grundpreis: 4056.54,
                weiteretausend: 116.21,
              },
              {
                menge: 20000,
                grundpreis: 5218.59,
                weiteretausend: 116.21,
              },
              {
                menge: 30000,
                grundpreis: 6380.65,
                weiteretausend: 116.21,
              },
              {
                menge: 40000,
                grundpreis: 7542.7,
                weiteretausend: 116.21,
              },
              {
                menge: 50000,
                grundpreis: 8704.76,
                weiteretausend: 116.21,
              },
              {
                menge: 100000,
                grundpreis: 14515.03,
                weiteretausend: 116.21,
              },
              {
                menge: 150000,
                grundpreis: 20325.3,
                weiteretausend: 116.21,
              },
              {
                menge: 200000,
                grundpreis: 26135.58,
                weiteretausend: 116.21,
              },
              {
                menge: 250000,
                grundpreis: 31945.85,
                weiteretausend: 116.21,
              },
              {
                menge: 300000,
                grundpreis: 37756.12,
                weiteretausend: 116.21,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 89,
            preise: [
              {
                menge: 2500,
                grundpreis: 2418.88,
                weiteretausend: 123.62,
              },
              {
                menge: 5000,
                grundpreis: 2622.77,
                weiteretausend: 123.62,
              },
              {
                menge: 10000,
                grundpreis: 3240.89,
                weiteretausend: 123.62,
              },
              {
                menge: 20000,
                grundpreis: 4477.14,
                weiteretausend: 123.62,
              },
              {
                menge: 30000,
                grundpreis: 5713.38,
                weiteretausend: 123.62,
              },
              {
                menge: 40000,
                grundpreis: 6949.63,
                weiteretausend: 123.62,
              },
              {
                menge: 50000,
                grundpreis: 8185.87,
                weiteretausend: 123.62,
              },
              {
                menge: 100000,
                grundpreis: 14367.1,
                weiteretausend: 123.62,
              },
              {
                menge: 150000,
                grundpreis: 20548.32,
                weiteretausend: 123.62,
              },
              {
                menge: 200000,
                grundpreis: 26729.55,
                weiteretausend: 123.62,
              },
              {
                menge: 250000,
                grundpreis: 32910.78,
                weiteretausend: 123.62,
              },
              {
                menge: 300000,
                grundpreis: 39092.0,
                weiteretausend: 123.62,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 104,
            preise: [
              {
                menge: 2500,
                grundpreis: 2642.6,
                weiteretausend: 157.75,
              },
              {
                menge: 5000,
                grundpreis: 2922.08,
                weiteretausend: 157.75,
              },
              {
                menge: 10000,
                grundpreis: 3710.82,
                weiteretausend: 157.75,
              },
              {
                menge: 20000,
                grundpreis: 5288.31,
                weiteretausend: 157.75,
              },
              {
                menge: 30000,
                grundpreis: 6865.8,
                weiteretausend: 157.75,
              },
              {
                menge: 40000,
                grundpreis: 8443.29,
                weiteretausend: 157.75,
              },
              {
                menge: 50000,
                grundpreis: 10020.78,
                weiteretausend: 157.75,
              },
              {
                menge: 100000,
                grundpreis: 17908.23,
                weiteretausend: 157.75,
              },
              {
                menge: 150000,
                grundpreis: 25795.68,
                weiteretausend: 157.75,
              },
              {
                menge: 200000,
                grundpreis: 33683.13,
                weiteretausend: 157.75,
              },
              {
                menge: 250000,
                grundpreis: 41570.58,
                weiteretausend: 157.75,
              },
              {
                menge: 300000,
                grundpreis: 49458.03,
                weiteretausend: 157.75,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 119,
            preise: [
              {
                menge: 2500,
                grundpreis: 2838.29,
                weiteretausend: 172.6,
              },
              {
                menge: 5000,
                grundpreis: 3146.39,
                weiteretausend: 172.6,
              },
              {
                menge: 10000,
                grundpreis: 4009.39,
                weiteretausend: 172.6,
              },
              {
                menge: 20000,
                grundpreis: 5735.4,
                weiteretausend: 172.6,
              },
              {
                menge: 30000,
                grundpreis: 7461.41,
                weiteretausend: 172.6,
              },
              {
                menge: 40000,
                grundpreis: 9187.42,
                weiteretausend: 172.6,
              },
              {
                menge: 50000,
                grundpreis: 10913.43,
                weiteretausend: 172.6,
              },
              {
                menge: 100000,
                grundpreis: 19543.48,
                weiteretausend: 172.6,
              },
              {
                menge: 150000,
                grundpreis: 28173.53,
                weiteretausend: 172.6,
              },
              {
                menge: 200000,
                grundpreis: 36803.58,
                weiteretausend: 172.6,
              },
              {
                menge: 250000,
                grundpreis: 45433.64,
                weiteretausend: 172.6,
              },
              {
                menge: 300000,
                grundpreis: 54063.69,
                weiteretausend: 172.6,
              },
            ],
          },
        ],
      },
      "Rota 80g": {
        type: "paged",
        bild: "produkt-beilage.png",
        kategoriename: "Beilage",
        verarbeitung: "beilagen",
        druckkosten: "seiten-gewicht-gestaffelt",
        minmenge: 5000,
        items: [
          {
            seiten: 4,
            gewicht: 11,
            preise: [
              {
                menge: 2500,
                grundpreis: 1761.6,
                weiteretausend: 51.52,
              },
              {
                menge: 5000,
                grundpreis: 1813.82,
                weiteretausend: 51.52,
              },
              {
                menge: 10000,
                grundpreis: 2071.44,
                weiteretausend: 51.52,
              },
              {
                menge: 20000,
                grundpreis: 2586.66,
                weiteretausend: 51.52,
              },
              {
                menge: 30000,
                grundpreis: 3101.89,
                weiteretausend: 51.52,
              },
              {
                menge: 40000,
                grundpreis: 3617.12,
                weiteretausend: 51.52,
              },
              {
                menge: 50000,
                grundpreis: 4132.35,
                weiteretausend: 51.52,
              },
              {
                menge: 100000,
                grundpreis: 6708.5,
                weiteretausend: 51.52,
              },
              {
                menge: 150000,
                grundpreis: 9284.65,
                weiteretausend: 51.52,
              },
              {
                menge: 200000,
                grundpreis: 11860.79,
                weiteretausend: 51.52,
              },
              {
                menge: 250000,
                grundpreis: 14436.94,
                weiteretausend: 51.52,
              },
              {
                menge: 300000,
                grundpreis: 17013.09,
                weiteretausend: 51.52,
              },
            ],
          },
          {
            seiten: 8,
            gewicht: 22,
            preise: [
              {
                menge: 2500,
                grundpreis: 1839.47,
                weiteretausend: 71.12,
              },
              {
                menge: 5000,
                grundpreis: 1937.3,
                weiteretausend: 71.12,
              },
              {
                menge: 10000,
                grundpreis: 2292.89,
                weiteretausend: 71.12,
              },
              {
                menge: 20000,
                grundpreis: 3004.09,
                weiteretausend: 71.12,
              },
              {
                menge: 30000,
                grundpreis: 3715.29,
                weiteretausend: 71.12,
              },
              {
                menge: 40000,
                grundpreis: 4426.49,
                weiteretausend: 71.12,
              },
              {
                menge: 50000,
                grundpreis: 5137.68,
                weiteretausend: 71.12,
              },
              {
                menge: 100000,
                grundpreis: 8693.67,
                weiteretausend: 71.12,
              },
              {
                menge: 150000,
                grundpreis: 12249.66,
                weiteretausend: 71.12,
              },
              {
                menge: 200000,
                grundpreis: 15805.65,
                weiteretausend: 71.12,
              },
              {
                menge: 250000,
                grundpreis: 19361.64,
                weiteretausend: 71.12,
              },
              {
                menge: 300000,
                grundpreis: 22917.62,
                weiteretausend: 71.12,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 32,
            preise: [
              {
                menge: 2500,
                grundpreis: 1917.34,
                weiteretausend: 90.72,
              },
              {
                menge: 5000,
                grundpreis: 2060.77,
                weiteretausend: 90.72,
              },
              {
                menge: 10000,
                grundpreis: 2514.35,
                weiteretausend: 90.72,
              },
              {
                menge: 20000,
                grundpreis: 3421.52,
                weiteretausend: 90.72,
              },
              {
                menge: 30000,
                grundpreis: 4328.68,
                weiteretausend: 90.72,
              },
              {
                menge: 40000,
                grundpreis: 5235.85,
                weiteretausend: 90.72,
              },
              {
                menge: 50000,
                grundpreis: 6143.02,
                weiteretausend: 90.72,
              },
              {
                menge: 100000,
                grundpreis: 10678.84,
                weiteretausend: 90.72,
              },
              {
                menge: 150000,
                grundpreis: 15214.67,
                weiteretausend: 90.72,
              },
              {
                menge: 200000,
                grundpreis: 19750.5,
                weiteretausend: 90.72,
              },
              {
                menge: 250000,
                grundpreis: 24286.33,
                weiteretausend: 90.72,
              },
              {
                menge: 300000,
                grundpreis: 28822.16,
                weiteretausend: 90.72,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 43,
            preise: [
              {
                menge: 2500,
                grundpreis: 1995.21,
                weiteretausend: 110.31,
              },
              {
                menge: 5000,
                grundpreis: 2184.24,
                weiteretausend: 110.31,
              },
              {
                menge: 10000,
                grundpreis: 2735.81,
                weiteretausend: 110.31,
              },
              {
                menge: 20000,
                grundpreis: 3838.95,
                weiteretausend: 110.31,
              },
              {
                menge: 30000,
                grundpreis: 4942.08,
                weiteretausend: 110.31,
              },
              {
                menge: 40000,
                grundpreis: 6045.21,
                weiteretausend: 110.31,
              },
              {
                menge: 50000,
                grundpreis: 7148.35,
                weiteretausend: 110.31,
              },
              {
                menge: 100000,
                grundpreis: 18179.69,
                weiteretausend: 110.31,
              },
              {
                menge: 150000,
                grundpreis: 18179.69,
                weiteretausend: 110.31,
              },
              {
                menge: 200000,
                grundpreis: 23695.36,
                weiteretausend: 110.31,
              },
              {
                menge: 250000,
                grundpreis: 29211.03,
                weiteretausend: 110.31,
              },
              {
                menge: 300000,
                grundpreis: 34726.7,
                weiteretausend: 110.31,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 54,
            preise: [
              {
                menge: 2500,
                grundpreis: 2370.82,
                weiteretausend: 129.9,
              },
              {
                menge: 5000,
                grundpreis: 2592.48,
                weiteretausend: 129.9,
              },
              {
                menge: 10000,
                grundpreis: 3241.97,
                weiteretausend: 129.9,
              },
              {
                menge: 20000,
                grundpreis: 4540.93,
                weiteretausend: 129.9,
              },
              {
                menge: 30000,
                grundpreis: 5839.89,
                weiteretausend: 129.9,
              },
              {
                menge: 40000,
                grundpreis: 7138.86,
                weiteretausend: 129.9,
              },
              {
                menge: 50000,
                grundpreis: 8437.82,
                weiteretausend: 129.9,
              },
              {
                menge: 100000,
                grundpreis: 14932.64,
                weiteretausend: 129.9,
              },
              {
                menge: 150000,
                grundpreis: 21427.45,
                weiteretausend: 129.9,
              },
              {
                menge: 200000,
                grundpreis: 27922.27,
                weiteretausend: 129.9,
              },
              {
                menge: 250000,
                grundpreis: 34417.08,
                weiteretausend: 129.9,
              },
              {
                menge: 300000,
                grundpreis: 40911.9,
                weiteretausend: 129.9,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 65,
            preise: [
              {
                menge: 2500,
                grundpreis: 2448.69,
                weiteretausend: 149.49,
              },
              {
                menge: 5000,
                grundpreis: 2715.96,
                weiteretausend: 149.49,
              },
              {
                menge: 10000,
                grundpreis: 3463.43,
                weiteretausend: 149.49,
              },
              {
                menge: 20000,
                grundpreis: 4958.36,
                weiteretausend: 149.49,
              },
              {
                menge: 30000,
                grundpreis: 6453.29,
                weiteretausend: 149.49,
              },
              {
                menge: 40000,
                grundpreis: 7948.22,
                weiteretausend: 149.49,
              },
              {
                menge: 50000,
                grundpreis: 9443.15,
                weiteretausend: 149.49,
              },
              {
                menge: 100000,
                grundpreis: 16917.81,
                weiteretausend: 149.49,
              },
              {
                menge: 150000,
                grundpreis: 24392.47,
                weiteretausend: 149.49,
              },
              {
                menge: 200000,
                grundpreis: 31867.12,
                weiteretausend: 149.49,
              },
              {
                menge: 250000,
                grundpreis: 39341.78,
                weiteretausend: 149.49,
              },
              {
                menge: 300000,
                grundpreis: 46816.44,
                weiteretausend: 149.49,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 86,
            preise: [
              {
                menge: 2500,
                grundpreis: 2604.43,
                weiteretausend: 188.69,
              },
              {
                menge: 5000,
                grundpreis: 2962.91,
                weiteretausend: 188.69,
              },
              {
                menge: 10000,
                grundpreis: 3906.34,
                weiteretausend: 188.69,
              },
              {
                menge: 20000,
                grundpreis: 5793.21,
                weiteretausend: 188.69,
              },
              {
                menge: 30000,
                grundpreis: 7680.08,
                weiteretausend: 188.69,
              },
              {
                menge: 40000,
                grundpreis: 9566.95,
                weiteretausend: 188.69,
              },
              {
                menge: 50000,
                grundpreis: 11453.81,
                weiteretausend: 188.69,
              },
              {
                menge: 100000,
                grundpreis: 20888.15,
                weiteretausend: 188.69,
              },
              {
                menge: 150000,
                grundpreis: 30322.49,
                weiteretausend: 188.69,
              },
              {
                menge: 200000,
                grundpreis: 39756.83,
                weiteretausend: 188.69,
              },
              {
                menge: 250000,
                grundpreis: 49191.17,
                weiteretausend: 188.69,
              },
              {
                menge: 300000,
                grundpreis: 58625.51,
                weiteretausend: 188.69,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 108,
            preise: [
              {
                menge: 2500,
                grundpreis: 3740.0,
                weiteretausend: 236.95,
              },
              {
                menge: 5000,
                grundpreis: 4169.76,
                weiteretausend: 236.95,
              },
              {
                menge: 10000,
                grundpreis: 5354.49,
                weiteretausend: 236.95,
              },
              {
                menge: 20000,
                grundpreis: 7723.96,
                weiteretausend: 236.95,
              },
              {
                menge: 30000,
                grundpreis: 10093.43,
                weiteretausend: 236.95,
              },
              {
                menge: 40000,
                grundpreis: 12462.89,
                weiteretausend: 236.95,
              },
              {
                menge: 50000,
                grundpreis: 14832.36,
                weiteretausend: 236.95,
              },
              {
                menge: 100000,
                grundpreis: 26679.68,
                weiteretausend: 236.95,
              },
              {
                menge: 150000,
                grundpreis: 38527.01,
                weiteretausend: 236.95,
              },
              {
                menge: 200000,
                grundpreis: 50374.34,
                weiteretausend: 236.95,
              },
              {
                menge: 250000,
                grundpreis: 62221.67,
                weiteretausend: 236.95,
              },
              {
                menge: 300000,
                grundpreis: 74069.0,
                weiteretausend: 236.95,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 130,
            preise: [
              {
                menge: 2500,
                grundpreis: 3910.24,
                weiteretausend: 281.69,
              },
              {
                menge: 5000,
                grundpreis: 4444.45,
                weiteretausend: 281.69,
              },
              {
                menge: 10000,
                grundpreis: 5852.89,
                weiteretausend: 281.69,
              },
              {
                menge: 20000,
                grundpreis: 8669.78,
                weiteretausend: 281.69,
              },
              {
                menge: 30000,
                grundpreis: 11486.66,
                weiteretausend: 281.69,
              },
              {
                menge: 40000,
                grundpreis: 14303.54,
                weiteretausend: 281.69,
              },
              {
                menge: 50000,
                grundpreis: 17120.43,
                weiteretausend: 281.69,
              },
              {
                menge: 100000,
                grundpreis: 31204.84,
                weiteretausend: 281.69,
              },
              {
                menge: 150000,
                grundpreis: 45289.26,
                weiteretausend: 281.69,
              },
              {
                menge: 200000,
                grundpreis: 59373.68,
                weiteretausend: 281.69,
              },
              {
                menge: 250000,
                grundpreis: 73458.1,
                weiteretausend: 281.69,
              },
              {
                menge: 300000,
                grundpreis: 87542.51,
                weiteretausend: 281.69,
              },
            ],
          },
        ],
      },
      "LWC glänzend": {
        type: "paged",
        bild: "produkt-beilage.png",
        kategoriename: "Beilage",
        verarbeitung: "beilagen",
        druckkosten: "seiten-gewicht-gestaffelt",
        minmenge: 5000,
        items: [
          {
            seiten: 8,
            gewicht: 17,
            preise: [
              {
                menge: 2500,
                grundpreis: 938.57,
                weiteretausend: 30.43,
              },
              {
                menge: 5000,
                grundpreis: 1014.64,
                weiteretausend: 30.43,
              },
              {
                menge: 10000,
                grundpreis: 1166.79,
                weiteretausend: 30.43,
              },
              {
                menge: 20000,
                grundpreis: 1471.08,
                weiteretausend: 30.43,
              },
              {
                menge: 30000,
                grundpreis: 1775.37,
                weiteretausend: 30.43,
              },
              {
                menge: 40000,
                grundpreis: 2079.66,
                weiteretausend: 30.43,
              },
              {
                menge: 50000,
                grundpreis: 2383.95,
                weiteretausend: 30.43,
              },
              {
                menge: 100000,
                grundpreis: 3905.4,
                weiteretausend: 30.43,
              },
              {
                menge: 150000,
                grundpreis: 5426.85,
                weiteretausend: 30.43,
              },
              {
                menge: 200000,
                grundpreis: 6948.3,
                weiteretausend: 30.43,
              },
              {
                menge: 250000,
                grundpreis: 8469.74,
                weiteretausend: 30.43,
              },
              {
                menge: 300000,
                grundpreis: 9991.19,
                weiteretausend: 30.43,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 26,
            preise: [
              {
                menge: 2500,
                grundpreis: 1012.29,
                weiteretausend: 46.11,
              },
              {
                menge: 5000,
                grundpreis: 1127.57,
                weiteretausend: 46.11,
              },
              {
                menge: 10000,
                grundpreis: 1358.14,
                weiteretausend: 46.11,
              },
              {
                menge: 20000,
                grundpreis: 1819.28,
                weiteretausend: 46.11,
              },
              {
                menge: 30000,
                grundpreis: 2280.42,
                weiteretausend: 46.11,
              },
              {
                menge: 40000,
                grundpreis: 2741.56,
                weiteretausend: 46.11,
              },
              {
                menge: 50000,
                grundpreis: 3202.7,
                weiteretausend: 46.11,
              },
              {
                menge: 100000,
                grundpreis: 5508.41,
                weiteretausend: 46.11,
              },
              {
                menge: 150000,
                grundpreis: 7814.11,
                weiteretausend: 46.11,
              },
              {
                menge: 200000,
                grundpreis: 10119.81,
                weiteretausend: 46.11,
              },
              {
                menge: 250000,
                grundpreis: 12425.52,
                weiteretausend: 46.11,
              },
              {
                menge: 300000,
                grundpreis: 14731.22,
                weiteretausend: 46.11,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 35,
            preise: [
              {
                menge: 2500,
                grundpreis: 1009.37,
                weiteretausend: 58.75,
              },
              {
                menge: 5000,
                grundpreis: 1156.24,
                weiteretausend: 58.75,
              },
              {
                menge: 10000,
                grundpreis: 1449.98,
                weiteretausend: 58.75,
              },
              {
                menge: 20000,
                grundpreis: 2037.45,
                weiteretausend: 58.75,
              },
              {
                menge: 30000,
                grundpreis: 2624.93,
                weiteretausend: 58.75,
              },
              {
                menge: 40000,
                grundpreis: 3212.41,
                weiteretausend: 58.75,
              },
              {
                menge: 50000,
                grundpreis: 3799.88,
                weiteretausend: 58.75,
              },
              {
                menge: 100000,
                grundpreis: 6737.27,
                weiteretausend: 58.75,
              },
              {
                menge: 150000,
                grundpreis: 9674.65,
                weiteretausend: 58.75,
              },
              {
                menge: 200000,
                grundpreis: 12612.04,
                weiteretausend: 58.75,
              },
              {
                menge: 250000,
                grundpreis: 15549.42,
                weiteretausend: 58.75,
              },
              {
                menge: 300000,
                grundpreis: 18486.8,
                weiteretausend: 58.75,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 44,
            preise: [
              {
                menge: 2500,
                grundpreis: 1734.53,
                weiteretausend: 72.81,
              },
              {
                menge: 5000,
                grundpreis: 1916.56,
                weiteretausend: 72.81,
              },
              {
                menge: 10000,
                grundpreis: 2280.62,
                weiteretausend: 72.81,
              },
              {
                menge: 20000,
                grundpreis: 3008.74,
                weiteretausend: 72.81,
              },
              {
                menge: 30000,
                grundpreis: 3736.87,
                weiteretausend: 72.81,
              },
              {
                menge: 40000,
                grundpreis: 4464.99,
                weiteretausend: 72.81,
              },
              {
                menge: 50000,
                grundpreis: 5193.11,
                weiteretausend: 72.81,
              },
              {
                menge: 100000,
                grundpreis: 8833.72,
                weiteretausend: 72.81,
              },
              {
                menge: 150000,
                grundpreis: 12474.33,
                weiteretausend: 72.81,
              },
              {
                menge: 200000,
                grundpreis: 16114.94,
                weiteretausend: 72.81,
              },
              {
                menge: 250000,
                grundpreis: 19755.54,
                weiteretausend: 72.81,
              },
              {
                menge: 300000,
                grundpreis: 23396.15,
                weiteretausend: 72.81,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 52,
            preise: [
              {
                menge: 2500,
                grundpreis: 1845.33,
                weiteretausend: 84.93,
              },
              {
                menge: 5000,
                grundpreis: 2057.67,
                weiteretausend: 84.93,
              },
              {
                menge: 10000,
                grundpreis: 2482.33,
                weiteretausend: 84.93,
              },
              {
                menge: 20000,
                grundpreis: 3331.67,
                weiteretausend: 84.93,
              },
              {
                menge: 30000,
                grundpreis: 4181.0,
                weiteretausend: 84.93,
              },
              {
                menge: 40000,
                grundpreis: 5030.33,
                weiteretausend: 84.93,
              },
              {
                menge: 50000,
                grundpreis: 5879.67,
                weiteretausend: 84.93,
              },
              {
                menge: 100000,
                grundpreis: 10126.34,
                weiteretausend: 84.93,
              },
              {
                menge: 150000,
                grundpreis: 14373.01,
                weiteretausend: 84.93,
              },
              {
                menge: 200000,
                grundpreis: 18619.67,
                weiteretausend: 84.93,
              },
              {
                menge: 250000,
                grundpreis: 22866.34,
                weiteretausend: 84.93,
              },
              {
                menge: 300000,
                grundpreis: 27113.01,
                weiteretausend: 84.93,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 61,
            preise: [
              {
                menge: 2500,
                grundpreis: 2397.35,
                weiteretausend: 107.94,
              },
              {
                menge: 5000,
                grundpreis: 2667.2,
                weiteretausend: 107.94,
              },
              {
                menge: 10000,
                grundpreis: 3206.89,
                weiteretausend: 107.94,
              },
              {
                menge: 20000,
                grundpreis: 4286.28,
                weiteretausend: 107.94,
              },
              {
                menge: 30000,
                grundpreis: 5365.68,
                weiteretausend: 107.94,
              },
              {
                menge: 40000,
                grundpreis: 6445.07,
                weiteretausend: 107.94,
              },
              {
                menge: 50000,
                grundpreis: 7524.46,
                weiteretausend: 107.94,
              },
              {
                menge: 100000,
                grundpreis: 12921.42,
                weiteretausend: 107.94,
              },
              {
                menge: 150000,
                grundpreis: 18318.38,
                weiteretausend: 107.94,
              },
              {
                menge: 200000,
                grundpreis: 23715.34,
                weiteretausend: 107.94,
              },
              {
                menge: 250000,
                grundpreis: 29112.3,
                weiteretausend: 107.94,
              },
              {
                menge: 300000,
                grundpreis: 34509.26,
                weiteretausend: 107.94,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 70,
            preise: [
              {
                menge: 2500,
                grundpreis: 2341.33,
                weiteretausend: 117.73,
              },
              {
                menge: 5000,
                grundpreis: 2635.66,
                weiteretausend: 117.73,
              },
              {
                menge: 10000,
                grundpreis: 3224.32,
                weiteretausend: 117.73,
              },
              {
                menge: 20000,
                grundpreis: 4401.65,
                weiteretausend: 117.73,
              },
              {
                menge: 30000,
                grundpreis: 5578.97,
                weiteretausend: 117.73,
              },
              {
                menge: 40000,
                grundpreis: 6756.29,
                weiteretausend: 117.73,
              },
              {
                menge: 50000,
                grundpreis: 7933.62,
                weiteretausend: 117.73,
              },
              {
                menge: 100000,
                grundpreis: 13820.23,
                weiteretausend: 117.73,
              },
              {
                menge: 150000,
                grundpreis: 19706.85,
                weiteretausend: 117.73,
              },
              {
                menge: 200000,
                grundpreis: 25593.47,
                weiteretausend: 117.73,
              },
              {
                menge: 250000,
                grundpreis: 31480.09,
                weiteretausend: 117.73,
              },
              {
                menge: 300000,
                grundpreis: 37366.7,
                weiteretausend: 117.73,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 78,
            preise: [
              {
                menge: 2500,
                grundpreis: 2789.48,
                weiteretausend: 135.99,
              },
              {
                menge: 5000,
                grundpreis: 3129.46,
                weiteretausend: 135.99,
              },
              {
                menge: 10000,
                grundpreis: 3809.42,
                weiteretausend: 135.99,
              },
              {
                menge: 20000,
                grundpreis: 5169.34,
                weiteretausend: 135.99,
              },
              {
                menge: 30000,
                grundpreis: 6529.26,
                weiteretausend: 135.99,
              },
              {
                menge: 40000,
                grundpreis: 7889.18,
                weiteretausend: 135.99,
              },
              {
                menge: 50000,
                grundpreis: 9249.1,
                weiteretausend: 135.99,
              },
              {
                menge: 100000,
                grundpreis: 16048.7,
                weiteretausend: 135.99,
              },
              {
                menge: 150000,
                grundpreis: 22848.29,
                weiteretausend: 135.99,
              },
              {
                menge: 200000,
                grundpreis: 29647.89,
                weiteretausend: 135.99,
              },
              {
                menge: 250000,
                grundpreis: 36447.49,
                weiteretausend: 135.99,
              },
              {
                menge: 300000,
                grundpreis: 43247.09,
                weiteretausend: 135.99,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 87,
            preise: [
              {
                menge: 2500,
                grundpreis: 2058.39,
                weiteretausend: 142.56,
              },
              {
                menge: 5000,
                grundpreis: 2414.78,
                weiteretausend: 142.56,
              },
              {
                menge: 10000,
                grundpreis: 3127.57,
                weiteretausend: 142.56,
              },
              {
                menge: 20000,
                grundpreis: 4553.13,
                weiteretausend: 142.56,
              },
              {
                menge: 30000,
                grundpreis: 5978.7,
                weiteretausend: 142.56,
              },
              {
                menge: 40000,
                grundpreis: 7404.27,
                weiteretausend: 142.56,
              },
              {
                menge: 50000,
                grundpreis: 8829.83,
                weiteretausend: 142.56,
              },
              {
                menge: 100000,
                grundpreis: 15957.67,
                weiteretausend: 142.56,
              },
              {
                menge: 150000,
                grundpreis: 23085.5,
                weiteretausend: 142.56,
              },
              {
                menge: 200000,
                grundpreis: 30213.33,
                weiteretausend: 142.56,
              },
              {
                menge: 250000,
                grundpreis: 37341.16,
                weiteretausend: 142.56,
              },
              {
                menge: 300000,
                grundpreis: 49983.2,
                weiteretausend: 142.56,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 96,
            preise: [
              {
                menge: 2500,
                grundpreis: 1077.35,
                weiteretausend: 179.4,
              },
              {
                menge: 5000,
                grundpreis: 1525.85,
                weiteretausend: 179.4,
              },
              {
                menge: 10000,
                grundpreis: 2422.85,
                weiteretausend: 179.4,
              },
              {
                menge: 20000,
                grundpreis: 4216.85,
                weiteretausend: 179.4,
              },
              {
                menge: 30000,
                grundpreis: 6010.85,
                weiteretausend: 179.4,
              },
              {
                menge: 40000,
                grundpreis: 7804.84,
                weiteretausend: 179.4,
              },
              {
                menge: 50000,
                grundpreis: 9598.84,
                weiteretausend: 179.4,
              },
              {
                menge: 100000,
                grundpreis: 18568.84,
                weiteretausend: 179.4,
              },
              {
                menge: 150000,
                grundpreis: 27538.84,
                weiteretausend: 179.4,
              },
              {
                menge: 200000,
                grundpreis: 36508.83,
                weiteretausend: 179.4,
              },
              {
                menge: 250000,
                grundpreis: 45478.83,
                weiteretausend: 179.4,
              },
              {
                menge: 300000,
                grundpreis: 54448.82,
                weiteretausend: 179.4,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 105,
            preise: [
              {
                menge: 2500,
                grundpreis: 2089.76,
                weiteretausend: 168.91,
              },
              {
                menge: 5000,
                grundpreis: 2512.03,
                weiteretausend: 168.91,
              },
              {
                menge: 10000,
                grundpreis: 3356.55,
                weiteretausend: 168.91,
              },
              {
                menge: 20000,
                grundpreis: 5045.61,
                weiteretausend: 168.91,
              },
              {
                menge: 30000,
                grundpreis: 6734.66,
                weiteretausend: 168.91,
              },
              {
                menge: 40000,
                grundpreis: 8423.72,
                weiteretausend: 168.91,
              },
              {
                menge: 50000,
                grundpreis: 10112.77,
                weiteretausend: 168.91,
              },
              {
                menge: 100000,
                grundpreis: 18558.04,
                weiteretausend: 168.91,
              },
              {
                menge: 150000,
                grundpreis: 27003.31,
                weiteretausend: 168.91,
              },
              {
                menge: 200000,
                grundpreis: 35448.58,
                weiteretausend: 168.91,
              },
              {
                menge: 250000,
                grundpreis: 43893.85,
                weiteretausend: 168.91,
              },
              {
                menge: 300000,
                grundpreis: 52339.11,
                weiteretausend: 168.91,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 122,
            preise: [
              {
                menge: 2500,
                grundpreis: 2496.04,
                weiteretausend: 207.22,
              },
              {
                menge: 5000,
                grundpreis: 3014.08,
                weiteretausend: 207.22,
              },
              {
                menge: 10000,
                grundpreis: 4050.17,
                weiteretausend: 207.22,
              },
              {
                menge: 20000,
                grundpreis: 6122.34,
                weiteretausend: 207.22,
              },
              {
                menge: 30000,
                grundpreis: 8194.51,
                weiteretausend: 207.22,
              },
              {
                menge: 40000,
                grundpreis: 10266.68,
                weiteretausend: 207.22,
              },
              {
                menge: 50000,
                grundpreis: 12338.85,
                weiteretausend: 207.22,
              },
              {
                menge: 100000,
                grundpreis: 22699.7,
                weiteretausend: 207.22,
              },
              {
                menge: 150000,
                grundpreis: 33060.55,
                weiteretausend: 207.22,
              },
              {
                menge: 200000,
                grundpreis: 43421.4,
                weiteretausend: 207.22,
              },
              {
                menge: 250000,
                grundpreis: 53782.24,
                weiteretausend: 207.22,
              },
              {
                menge: 300000,
                grundpreis: 64143.09,
                weiteretausend: 207.22,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 140,
            preise: [
              {
                menge: 2500,
                grundpreis: 2708.12,
                weiteretausend: 234.55,
              },
              {
                menge: 5000,
                grundpreis: 3294.5,
                weiteretausend: 234.55,
              },
              {
                menge: 10000,
                grundpreis: 4467.24,
                weiteretausend: 234.55,
              },
              {
                menge: 20000,
                grundpreis: 6812.73,
                weiteretausend: 234.55,
              },
              {
                menge: 30000,
                grundpreis: 9158.22,
                weiteretausend: 234.55,
              },
              {
                menge: 40000,
                grundpreis: 11503.71,
                weiteretausend: 234.55,
              },
              {
                menge: 50000,
                grundpreis: 13849.2,
                weiteretausend: 234.55,
              },
              {
                menge: 100000,
                grundpreis: 25576.66,
                weiteretausend: 234.55,
              },
              {
                menge: 150000,
                grundpreis: 37304.11,
                weiteretausend: 234.55,
              },
              {
                menge: 200000,
                grundpreis: 49031.56,
                weiteretausend: 234.55,
              },
              {
                menge: 250000,
                grundpreis: 60759.01,
                weiteretausend: 234.55,
              },
              {
                menge: 300000,
                grundpreis: 72486.47,
                weiteretausend: 234.55,
              },
            ],
          },
          {
            seiten: 72,
            gewicht: 158,
            preise: [
              {
                menge: 2500,
                grundpreis: 3398.29,
                weiteretausend: 259.92,
              },
              {
                menge: 5000,
                grundpreis: 4048.08,
                weiteretausend: 259.92,
              },
              {
                menge: 10000,
                grundpreis: 5347.66,
                weiteretausend: 259.92,
              },
              {
                menge: 20000,
                grundpreis: 7946.81,
                weiteretausend: 259.92,
              },
              {
                menge: 30000,
                grundpreis: 10545.97,
                weiteretausend: 259.92,
              },
              {
                menge: 40000,
                grundpreis: 13145.12,
                weiteretausend: 259.92,
              },
              {
                menge: 50000,
                grundpreis: 15744.28,
                weiteretausend: 259.92,
              },
              {
                menge: 100000,
                grundpreis: 28740.06,
                weiteretausend: 259.92,
              },
              {
                menge: 150000,
                grundpreis: 41735.84,
                weiteretausend: 259.92,
              },
              {
                menge: 200000,
                grundpreis: 54731.61,
                weiteretausend: 259.92,
              },
              {
                menge: 250000,
                grundpreis: 67727.39,
                weiteretausend: 259.92,
              },
              {
                menge: 300000,
                grundpreis: 80723.17,
                weiteretausend: 259.92,
              },
            ],
          },
        ],
      },
      "LWC matt": {
        type: "paged",
        bild: "produkt-beilage.png",
        kategoriename: "Beilage",
        verarbeitung: "beilagen",
        druckkosten: "seiten-gewicht-gestaffelt",
        minmenge: 5000,
        items: [
          {
            seiten: 8,
            gewicht: 16,
            preise: [
              {
                menge: 2500,
                grundpreis: 936.51,
                weiteretausend: 29.6,
              },
              {
                menge: 5000,
                grundpreis: 1010.51,
                weiteretausend: 29.6,
              },
              {
                menge: 10000,
                grundpreis: 1158.52,
                weiteretausend: 29.6,
              },
              {
                menge: 20000,
                grundpreis: 1454.54,
                weiteretausend: 29.6,
              },
              {
                menge: 30000,
                grundpreis: 1750.56,
                weiteretausend: 29.6,
              },
              {
                menge: 40000,
                grundpreis: 2046.58,
                weiteretausend: 29.6,
              },
              {
                menge: 50000,
                grundpreis: 2342.6,
                weiteretausend: 29.6,
              },
              {
                menge: 100000,
                grundpreis: 3822.7,
                weiteretausend: 29.6,
              },
              {
                menge: 150000,
                grundpreis: 5302.8,
                weiteretausend: 29.6,
              },
              {
                menge: 200000,
                grundpreis: 6782.91,
                weiteretausend: 29.6,
              },
              {
                menge: 250000,
                grundpreis: 8263.01,
                weiteretausend: 29.6,
              },
              {
                menge: 300000,
                grundpreis: 9743.11,
                weiteretausend: 29.6,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 24,
            preise: [
              {
                menge: 2500,
                grundpreis: 1009.24,
                weiteretausend: 44.9,
              },
              {
                menge: 5000,
                grundpreis: 1121.48,
                weiteretausend: 44.9,
              },
              {
                menge: 10000,
                grundpreis: 1345.97,
                weiteretausend: 44.9,
              },
              {
                menge: 20000,
                grundpreis: 1794.93,
                weiteretausend: 44.9,
              },
              {
                menge: 30000,
                grundpreis: 2243.9,
                weiteretausend: 44.9,
              },
              {
                menge: 40000,
                grundpreis: 2692.87,
                weiteretausend: 44.9,
              },
              {
                menge: 50000,
                grundpreis: 3141.83,
                weiteretausend: 44.9,
              },
              {
                menge: 100000,
                grundpreis: 5386.67,
                weiteretausend: 44.9,
              },
              {
                menge: 150000,
                grundpreis: 7631.5,
                weiteretausend: 44.9,
              },
              {
                menge: 200000,
                grundpreis: 9876.33,
                weiteretausend: 44.9,
              },
              {
                menge: 250000,
                grundpreis: 12121.17,
                weiteretausend: 44.9,
              },
              {
                menge: 300000,
                grundpreis: 14366.0,
                weiteretausend: 44.9,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 32,
            preise: [
              {
                menge: 2500,
                grundpreis: 1005.33,
                weiteretausend: 57.13,
              },
              {
                menge: 5000,
                grundpreis: 1148.16,
                weiteretausend: 57.13,
              },
              {
                menge: 10000,
                grundpreis: 1433.82,
                weiteretausend: 57.13,
              },
              {
                menge: 20000,
                grundpreis: 2005.14,
                weiteretausend: 57.13,
              },
              {
                menge: 30000,
                grundpreis: 2576.47,
                weiteretausend: 57.13,
              },
              {
                menge: 40000,
                grundpreis: 3147.79,
                weiteretausend: 57.13,
              },
              {
                menge: 50000,
                grundpreis: 3719.11,
                weiteretausend: 57.13,
              },
              {
                menge: 100000,
                grundpreis: 6575.72,
                weiteretausend: 57.13,
              },
              {
                menge: 150000,
                grundpreis: 9432.34,
                weiteretausend: 57.13,
              },
              {
                menge: 200000,
                grundpreis: 12288.95,
                weiteretausend: 57.13,
              },
              {
                menge: 250000,
                grundpreis: 15145.56,
                weiteretausend: 57.13,
              },
              {
                menge: 300000,
                grundpreis: 18002.17,
                weiteretausend: 57.13,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 41,
            preise: [
              {
                menge: 2500,
                grundpreis: 1729.34,
                weiteretausend: 70.74,
              },
              {
                menge: 5000,
                grundpreis: 1906.18,
                weiteretausend: 70.74,
              },
              {
                menge: 10000,
                grundpreis: 2259.86,
                weiteretausend: 70.74,
              },
              {
                menge: 20000,
                grundpreis: 2967.21,
                weiteretausend: 70.74,
              },
              {
                menge: 30000,
                grundpreis: 3674.57,
                weiteretausend: 70.74,
              },
              {
                menge: 40000,
                grundpreis: 4381.92,
                weiteretausend: 70.74,
              },
              {
                menge: 50000,
                grundpreis: 5089.28,
                weiteretausend: 70.74,
              },
              {
                menge: 100000,
                grundpreis: 8626.05,
                weiteretausend: 70.74,
              },
              {
                menge: 150000,
                grundpreis: 12162.83,
                weiteretausend: 70.74,
              },
              {
                menge: 200000,
                grundpreis: 15699.61,
                weiteretausend: 70.74,
              },
              {
                menge: 250000,
                grundpreis: 19236.38,
                weiteretausend: 70.74,
              },
              {
                menge: 300000,
                grundpreis: 22773.16,
                weiteretausend: 70.74,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 49,
            preise: [
              {
                menge: 2500,
                grundpreis: 1839.1,
                weiteretausend: 82.44,
              },
              {
                menge: 5000,
                grundpreis: 2045.21,
                weiteretausend: 82.44,
              },
              {
                menge: 10000,
                grundpreis: 2457.41,
                weiteretausend: 82.44,
              },
              {
                menge: 20000,
                grundpreis: 3281.82,
                weiteretausend: 82.44,
              },
              {
                menge: 30000,
                grundpreis: 4106.23,
                weiteretausend: 82.44,
              },
              {
                menge: 40000,
                grundpreis: 4930.64,
                weiteretausend: 82.44,
              },
              {
                menge: 50000,
                grundpreis: 5755.06,
                weiteretausend: 82.44,
              },
              {
                menge: 100000,
                grundpreis: 9877.11,
                weiteretausend: 82.44,
              },
              {
                menge: 150000,
                grundpreis: 13999.17,
                weiteretausend: 82.44,
              },
              {
                menge: 200000,
                grundpreis: 18121.22,
                weiteretausend: 82.44,
              },
              {
                menge: 250000,
                grundpreis: 22243.28,
                weiteretausend: 82.44,
              },
              {
                menge: 300000,
                grundpreis: 26365.33,
                weiteretausend: 82.44,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 57,
            preise: [
              {
                menge: 2500,
                grundpreis: 2389.7,
                weiteretausend: 104.88,
              },
              {
                menge: 5000,
                grundpreis: 2651.9,
                weiteretausend: 104.88,
              },
              {
                menge: 10000,
                grundpreis: 3176.3,
                weiteretausend: 104.88,
              },
              {
                menge: 20000,
                grundpreis: 4225.1,
                weiteretausend: 104.88,
              },
              {
                menge: 30000,
                grundpreis: 5273.89,
                weiteretausend: 104.88,
              },
              {
                menge: 40000,
                grundpreis: 6322.69,
                weiteretausend: 104.88,
              },
              {
                menge: 50000,
                grundpreis: 7371.49,
                weiteretausend: 104.88,
              },
              {
                menge: 100000,
                grundpreis: 12615.48,
                weiteretausend: 104.88,
              },
              {
                menge: 150000,
                grundpreis: 17859.47,
                weiteretausend: 104.88,
              },
              {
                menge: 200000,
                grundpreis: 23103.46,
                weiteretausend: 104.88,
              },
              {
                menge: 250000,
                grundpreis: 28347.45,
                weiteretausend: 104.88,
              },
              {
                menge: 300000,
                grundpreis: 33591.44,
                weiteretausend: 104.88,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 65,
            preise: [
              {
                menge: 2500,
                grundpreis: 2332.74,
                weiteretausend: 114.3,
              },
              {
                menge: 5000,
                grundpreis: 2618.48,
                weiteretausend: 114.3,
              },
              {
                menge: 10000,
                grundpreis: 3189.97,
                weiteretausend: 114.3,
              },
              {
                menge: 20000,
                grundpreis: 4332.94,
                weiteretausend: 114.3,
              },
              {
                menge: 30000,
                grundpreis: 5475.9,
                weiteretausend: 114.3,
              },
              {
                menge: 40000,
                grundpreis: 6618.87,
                weiteretausend: 114.3,
              },
              {
                menge: 50000,
                grundpreis: 7761.84,
                weiteretausend: 114.3,
              },
              {
                menge: 100000,
                grundpreis: 13476.68,
                weiteretausend: 114.3,
              },
              {
                menge: 150000,
                grundpreis: 19191.51,
                weiteretausend: 114.3,
              },
              {
                menge: 200000,
                grundpreis: 24906.35,
                weiteretausend: 114.3,
              },
              {
                menge: 250000,
                grundpreis: 30621.19,
                weiteretausend: 114.3,
              },
              {
                menge: 300000,
                grundpreis: 36336.03,
                weiteretausend: 114.3,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 73,
            preise: [
              {
                menge: 2500,
                grundpreis: 2779.69,
                weiteretausend: 132.08,
              },
              {
                menge: 5000,
                grundpreis: 3109.88,
                weiteretausend: 132.08,
              },
              {
                menge: 10000,
                grundpreis: 3770.26,
                weiteretausend: 132.08,
              },
              {
                menge: 20000,
                grundpreis: 5091.01,
                weiteretausend: 132.08,
              },
              {
                menge: 30000,
                grundpreis: 6411.77,
                weiteretausend: 132.08,
              },
              {
                menge: 40000,
                grundpreis: 7732.53,
                weiteretausend: 132.08,
              },
              {
                menge: 50000,
                grundpreis: 9053.28,
                weiteretausend: 132.08,
              },
              {
                menge: 100000,
                grundpreis: 15657.07,
                weiteretausend: 132.08,
              },
              {
                menge: 150000,
                grundpreis: 22260.85,
                weiteretausend: 132.08,
              },
              {
                menge: 200000,
                grundpreis: 28864.64,
                weiteretausend: 132.08,
              },
              {
                menge: 250000,
                grundpreis: 35468.42,
                weiteretausend: 132.08,
              },
              {
                menge: 300000,
                grundpreis: 42072.21,
                weiteretausend: 132.08,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 81,
            preise: [
              {
                menge: 2500,
                grundpreis: 2048.25,
                weiteretausend: 138.5,
              },
              {
                menge: 5000,
                grundpreis: 2394.49,
                weiteretausend: 138.5,
              },
              {
                menge: 10000,
                grundpreis: 3086.98,
                weiteretausend: 138.5,
              },
              {
                menge: 20000,
                grundpreis: 4471.97,
                weiteretausend: 138.5,
              },
              {
                menge: 30000,
                grundpreis: 5856.95,
                weiteretausend: 138.5,
              },
              {
                menge: 40000,
                grundpreis: 7241.93,
                weiteretausend: 138.5,
              },
              {
                menge: 50000,
                grundpreis: 8626.92,
                weiteretausend: 138.5,
              },
              {
                menge: 100000,
                grundpreis: 15551.84,
                weiteretausend: 138.5,
              },
              {
                menge: 150000,
                grundpreis: 22476.75,
                weiteretausend: 138.5,
              },
              {
                menge: 200000,
                grundpreis: 29401.67,
                weiteretausend: 138.5,
              },
              {
                menge: 250000,
                grundpreis: 36326.59,
                weiteretausend: 138.5,
              },
              {
                menge: 300000,
                grundpreis: 43251.51,
                weiteretausend: 138.5,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 89,
            preise: [
              {
                menge: 2500,
                grundpreis: 1054.31,
                weiteretausend: 172.7,
              },
              {
                menge: 5000,
                grundpreis: 1486.06,
                weiteretausend: 172.7,
              },
              {
                menge: 10000,
                grundpreis: 2349.56,
                weiteretausend: 172.7,
              },
              {
                menge: 20000,
                grundpreis: 4076.55,
                weiteretausend: 172.7,
              },
              {
                menge: 30000,
                grundpreis: 5803.55,
                weiteretausend: 172.7,
              },
              {
                menge: 40000,
                grundpreis: 7530.55,
                weiteretausend: 172.7,
              },
              {
                menge: 50000,
                grundpreis: 9257.55,
                weiteretausend: 172.7,
              },
              {
                menge: 100000,
                grundpreis: 17892.54,
                weiteretausend: 172.7,
              },
              {
                menge: 150000,
                grundpreis: 26527.52,
                weiteretausend: 172.7,
              },
              {
                menge: 200000,
                grundpreis: 35162.51,
                weiteretausend: 172.7,
              },
              {
                menge: 250000,
                grundpreis: 43797.5,
                weiteretausend: 172.7,
              },
              {
                menge: 300000,
                grundpreis: 52432.49,
                weiteretausend: 172.7,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 97,
            preise: [
              {
                menge: 2500,
                grundpreis: 2077.59,
                weiteretausend: 164.04,
              },
              {
                menge: 5000,
                grundpreis: 2487.68,
                weiteretausend: 164.04,
              },
              {
                menge: 10000,
                grundpreis: 3307.85,
                weiteretausend: 164.04,
              },
              {
                menge: 20000,
                grundpreis: 4948.21,
                weiteretausend: 164.04,
              },
              {
                menge: 30000,
                grundpreis: 6588.56,
                weiteretausend: 164.04,
              },
              {
                menge: 40000,
                grundpreis: 8228.91,
                weiteretausend: 164.04,
              },
              {
                menge: 50000,
                grundpreis: 9869.27,
                weiteretausend: 164.04,
              },
              {
                menge: 100000,
                grundpreis: 18071.04,
                weiteretausend: 164.04,
              },
              {
                menge: 150000,
                grundpreis: 26272.81,
                weiteretausend: 164.04,
              },
              {
                menge: 200000,
                grundpreis: 34474.57,
                weiteretausend: 164.04,
              },
              {
                menge: 250000,
                grundpreis: 42676.34,
                weiteretausend: 164.04,
              },
              {
                menge: 300000,
                grundpreis: 50878.11,
                weiteretausend: 164.04,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 114,
            preise: [
              {
                menge: 2500,
                grundpreis: 2481.39,
                weiteretausend: 201.36,
              },
              {
                menge: 5000,
                grundpreis: 2984.78,
                weiteretausend: 201.36,
              },
              {
                menge: 10000,
                grundpreis: 3991.56,
                weiteretausend: 201.36,
              },
              {
                menge: 20000,
                grundpreis: 6005.12,
                weiteretausend: 201.36,
              },
              {
                menge: 30000,
                grundpreis: 8018.68,
                weiteretausend: 201.36,
              },
              {
                menge: 40000,
                grundpreis: 10032.24,
                weiteretausend: 201.36,
              },
              {
                menge: 50000,
                grundpreis: 12045.81,
                weiteretausend: 201.36,
              },
              {
                menge: 100000,
                grundpreis: 22113.61,
                weiteretausend: 201.36,
              },
              {
                menge: 150000,
                grundpreis: 32181.42,
                weiteretausend: 201.36,
              },
              {
                menge: 200000,
                grundpreis: 42249.22,
                weiteretausend: 201.36,
              },
              {
                menge: 250000,
                grundpreis: 52317.03,
                weiteretausend: 201.36,
              },
              {
                menge: 300000,
                grundpreis: 62384.83,
                weiteretausend: 201.36,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 130,
            preise: [
              {
                menge: 2500,
                grundpreis: 2691.53,
                weiteretausend: 227.91,
              },
              {
                menge: 5000,
                grundpreis: 3261.31,
                weiteretausend: 227.91,
              },
              {
                menge: 10000,
                grundpreis: 4400.87,
                weiteretausend: 227.91,
              },
              {
                menge: 20000,
                grundpreis: 6679.99,
                weiteretausend: 227.91,
              },
              {
                menge: 30000,
                grundpreis: 8959.11,
                weiteretausend: 227.91,
              },
              {
                menge: 40000,
                grundpreis: 11238.23,
                weiteretausend: 227.91,
              },
              {
                menge: 50000,
                grundpreis: 13517.35,
                weiteretausend: 227.91,
              },
              {
                menge: 100000,
                grundpreis: 24912.96,
                weiteretausend: 227.91,
              },
              {
                menge: 150000,
                grundpreis: 36308.56,
                weiteretausend: 227.91,
              },
              {
                menge: 200000,
                grundpreis: 47704.16,
                weiteretausend: 227.91,
              },
              {
                menge: 250000,
                grundpreis: 59099.76,
                weiteretausend: 227.91,
              },
              {
                menge: 300000,
                grundpreis: 70495.37,
                weiteretausend: 227.91,
              },
            ],
          },
          {
            seiten: 72,
            gewicht: 146,
            preise: [
              {
                menge: 2500,
                grundpreis: 3379.54,
                weiteretausend: 252.41,
              },
              {
                menge: 5000,
                grundpreis: 4010.57,
                weiteretausend: 252.41,
              },
              {
                menge: 10000,
                grundpreis: 5272.65,
                weiteretausend: 252.41,
              },
              {
                menge: 20000,
                grundpreis: 7796.79,
                weiteretausend: 252.41,
              },
              {
                menge: 30000,
                grundpreis: 10320.94,
                weiteretausend: 252.41,
              },
              {
                menge: 40000,
                grundpreis: 12845.08,
                weiteretausend: 252.41,
              },
              {
                menge: 50000,
                grundpreis: 15369.23,
                weiteretausend: 252.41,
              },
              {
                menge: 100000,
                grundpreis: 27989.96,
                weiteretausend: 252.41,
              },
              {
                menge: 150000,
                grundpreis: 40610.69,
                weiteretausend: 252.41,
              },
              {
                menge: 200000,
                grundpreis: 53231.41,
                weiteretausend: 252.41,
              },
              {
                menge: 250000,
                grundpreis: 65852.14,
                weiteretausend: 252.41,
              },
              {
                menge: 300000,
                grundpreis: 78472.87,
                weiteretausend: 252.41,
              },
            ],
          },
        ],
      },
    },
    Mantel: {
      "Rota 80g": {
        type: "paged",
        bild: "produkt-mantel.png",
        kategoriename: "Mantel",
        verarbeitung: "mantel",
        druckkosten: "seiten-gestaffelt",
        minmenge: 5000,

        items: [
          {
            seiten: 4,
            gewicht: 11,
            preise: [
              {
                menge: 2500,
                grundpreis: 1761.6,
                weiteretausend: 51.52,
              },
              {
                menge: 5000,
                grundpreis: 1813.82,
                weiteretausend: 51.52,
              },
              {
                menge: 10000,
                grundpreis: 2071.44,
                weiteretausend: 51.52,
              },
              {
                menge: 20000,
                grundpreis: 2586.66,
                weiteretausend: 51.52,
              },
              {
                menge: 30000,
                grundpreis: 3101.89,
                weiteretausend: 51.52,
              },
              {
                menge: 40000,
                grundpreis: 3617.12,
                weiteretausend: 51.52,
              },
              {
                menge: 50000,
                grundpreis: 4132.35,
                weiteretausend: 51.52,
              },
              {
                menge: 100000,
                grundpreis: 6708.5,
                weiteretausend: 51.52,
              },
              {
                menge: 150000,
                grundpreis: 9284.65,
                weiteretausend: 51.52,
              },
              {
                menge: 200000,
                grundpreis: 11860.79,
                weiteretausend: 51.52,
              },
              {
                menge: 250000,
                grundpreis: 14436.94,
                weiteretausend: 51.52,
              },
              {
                menge: 300000,
                grundpreis: 17013.09,
                weiteretausend: 51.52,
              },
            ],
          },
          {
            seiten: 8,
            gewicht: 22,
            preise: [
              {
                menge: 2500,
                grundpreis: 1839.47,
                weiteretausend: 71.12,
              },
              {
                menge: 5000,
                grundpreis: 1937.3,
                weiteretausend: 71.12,
              },
              {
                menge: 10000,
                grundpreis: 2292.89,
                weiteretausend: 71.12,
              },
              {
                menge: 20000,
                grundpreis: 3004.09,
                weiteretausend: 71.12,
              },
              {
                menge: 30000,
                grundpreis: 3715.29,
                weiteretausend: 71.12,
              },
              {
                menge: 40000,
                grundpreis: 4426.49,
                weiteretausend: 71.12,
              },
              {
                menge: 50000,
                grundpreis: 5137.68,
                weiteretausend: 71.12,
              },
              {
                menge: 100000,
                grundpreis: 8693.67,
                weiteretausend: 71.12,
              },
              {
                menge: 150000,
                grundpreis: 12249.66,
                weiteretausend: 71.12,
              },
              {
                menge: 200000,
                grundpreis: 15805.65,
                weiteretausend: 71.12,
              },
              {
                menge: 250000,
                grundpreis: 19361.64,
                weiteretausend: 71.12,
              },
              {
                menge: 300000,
                grundpreis: 22917.62,
                weiteretausend: 71.12,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 32,
            preise: [
              {
                menge: 2500,
                grundpreis: 1917.34,
                weiteretausend: 90.72,
              },
              {
                menge: 5000,
                grundpreis: 2060.77,
                weiteretausend: 90.72,
              },
              {
                menge: 10000,
                grundpreis: 2514.35,
                weiteretausend: 90.72,
              },
              {
                menge: 20000,
                grundpreis: 3421.52,
                weiteretausend: 90.72,
              },
              {
                menge: 30000,
                grundpreis: 4328.68,
                weiteretausend: 90.72,
              },
              {
                menge: 40000,
                grundpreis: 5235.85,
                weiteretausend: 90.72,
              },
              {
                menge: 50000,
                grundpreis: 6143.02,
                weiteretausend: 90.72,
              },
              {
                menge: 100000,
                grundpreis: 10678.84,
                weiteretausend: 90.72,
              },
              {
                menge: 150000,
                grundpreis: 15214.67,
                weiteretausend: 90.72,
              },
              {
                menge: 200000,
                grundpreis: 19750.5,
                weiteretausend: 90.72,
              },
              {
                menge: 250000,
                grundpreis: 24286.33,
                weiteretausend: 90.72,
              },
              {
                menge: 300000,
                grundpreis: 28822.16,
                weiteretausend: 90.72,
              },
            ],
          },
        ],
      },
      LWC: {
        type: "single",
        bild: "produkt-mantel.png",
        kategoriename: "Mantel",
        verarbeitung: "mantel",
        druckkosten: "gestaffelt",
        minmenge: 5000,
        gewicht: 11,
        items: [
          {
            menge: 2500,
            grundpreis: 563.5,
            weiteretausend: 80.02,
          },
          {
            menge: 5000,
            grundpreis: 735,
            weiteretausend: 104.37,
          },
          {
            menge: 10000,
            grundpreis: 1087.5,
            weiteretausend: 93.58,
          },
          {
            menge: 20000,
            grundpreis: 1750,
            weiteretausend: 84.98,
          },
          {
            menge: 30000,
            grundpreis: 2227.5,
            weiteretausend: 81.89,
          },
          {
            menge: 40000,
            grundpreis: 2598.7,
            weiteretausend: 57.85,
          },
          {
            menge: 50000,
            grundpreis: 3062.5,
            weiteretausend: 55.63,
          },
          {
            menge: 100000,
            grundpreis: 5700,
            weiteretausend: 53.4,
          },
          {
            menge: 200000,
            grundpreis: 10798.5,
            weiteretausend: 53.4,
          },
          {
            menge: 300000,
            grundpreis: 15927.5,
            weiteretausend: 53.4,
          },
        ],
      },
    },
    "Tip on Card": {
      Titelseite: {
        bild: "produkt-tiponcard.png",
        kategoriename: "Tip on Card",
        type: "titelseite",
        verarbeitung: "toc",
        druckkosten: "gestaffelt",
        minmenge: 40000,
        items: [
          {
            menge: 2500,
            grundpreis: 212.16,
            weiteretausend: 15.27,
          },
          {
            menge: 5000,
            grundpreis: 244.8,
            weiteretausend: 15.27,
          },
          {
            menge: 10000,
            grundpreis: 316.8,
            weiteretausend: 15.27,
          },
          {
            menge: 20000,
            grundpreis: 468.0,
            weiteretausend: 15.27,
          },
          {
            menge: 30000,
            grundpreis: 604.8,
            weiteretausend: 15.27,
          },
          {
            menge: 40000,
            grundpreis: 702.96,
            weiteretausend: 14.76,
          },
          {
            menge: 50000,
            grundpreis: 840.0,
            weiteretausend: 14.11,
          },
          {
            menge: 100000,
            grundpreis: 1360.8,
            weiteretausend: 12.83,
          },
          {
            menge: 200000,
            grundpreis: 2184.0,
            weiteretausend: 12.1,
          },
          {
            menge: 300000,
            grundpreis: 2912.5,
            weiteretausend: 11.64,
          },
          {
            menge: 400000,
            grundpreis: 3480.0,
            weiteretausend: 11.17,
          },
        ],
      },
      U4: {
        bild: "produkt-postkarte.png",
        kategoriename: "Postkarte",
        type: "u4",
        verarbeitung: "toc",
        druckkosten: "gestaffelt",
        minmenge: 5000,
        items: [
          {
            menge: 2500,
            grundpreis: 212.16,
            weiteretausend: 15.27,
          },
          {
            menge: 5000,
            grundpreis: 244.8,
            weiteretausend: 15.27,
          },
          {
            menge: 10000,
            grundpreis: 316.8,
            weiteretausend: 15.27,
          },
          {
            menge: 20000,
            grundpreis: 468.0,
            weiteretausend: 15.27,
          },
          {
            menge: 30000,
            grundpreis: 604.8,
            weiteretausend: 15.27,
          },
          {
            menge: 40000,
            grundpreis: 702.96,
            weiteretausend: 14.76,
          },
          {
            menge: 50000,
            grundpreis: 840.0,
            weiteretausend: 14.11,
          },
          {
            menge: 100000,
            grundpreis: 1360.8,
            weiteretausend: 12.83,
          },
          {
            menge: 200000,
            grundpreis: 2184.0,
            weiteretausend: 12.1,
          },
          {
            menge: 300000,
            grundpreis: 2912.5,
            weiteretausend: 11.64,
          },
          {
            menge: 400000,
            grundpreis: 3480.0,
            weiteretausend: 11.17,
          },
        ],
      },
    },
    Flyer: {
      none: {
        type: "single",
        bild: "produkt-flyer.png",
        kategoriename: "Flyer",
        verarbeitung: "beilagen",
        druckkosten: "gestaffelt",
        minmenge: 5000,
        gewicht: 20,
        items: [
          {
            menge: 2500,
            grundpreis: 372,
            weiteretausend: 45.44,
          },
          {
            menge: 5000,
            grundpreis: 465,
            weiteretausend: 45.44,
          },
          {
            menge: 10000,
            grundpreis: 645,
            weiteretausend: 42.56,
          },
          {
            menge: 20000,
            grundpreis: 949.75,
            weiteretausend: 38.31,
          },
          {
            menge: 30000,
            grundpreis: 1254.25,
            weiteretausend: 36.92,
          },
          {
            menge: 40000,
            grundpreis: 1470,
            weiteretausend: 31.5,
          },
          {
            menge: 50000,
            grundpreis: 1708,
            weiteretausend: 31.5,
          },
          {
            menge: 100000,
            grundpreis: 2782,
            weiteretausend: 29.25,
          },
          {
            menge: 200000,
            grundpreis: 4704,
            weiteretausend: 23.88,
          },
          {
            menge: 300000,
            grundpreis: 6624,
            weiteretausend: 23.88,
          },
        ],
      },
    },
    Folder: {
      none: {
        type: "single",
        bild: "produkt-folder.png",
        kategoriename: "Folder",
        verarbeitung: "beilagen",
        druckkosten: "gestaffelt",
        minmenge: 5000,
        gewicht: 20,
        items: [
          {
            menge: 2500,
            grundpreis: 488.4,
            weiteretausend: 84.89,
          },
          {
            menge: 5000,
            grundpreis: 666,
            weiteretausend: 84.89,
          },
          {
            menge: 10000,
            grundpreis: 1005,
            weiteretausend: 76.65,
          },
          {
            menge: 20000,
            grundpreis: 1612.5,
            weiteretausend: 70.71,
          },
          {
            menge: 30000,
            grundpreis: 2130,
            weiteretausend: 70.44,
          },
          {
            menge: 40000,
            grundpreis: 2617.5,
            weiteretausend: 58.35,
          },
          {
            menge: 50000,
            grundpreis: 2954,
            weiteretausend: 54.46,
          },
          {
            menge: 100000,
            grundpreis: 5265,
            weiteretausend: 50.57,
          },
          {
            menge: 200000,
            grundpreis: 9480,
            weiteretausend: 45.48,
          },
          {
            menge: 300000,
            grundpreis: 13800,
            weiteretausend: 45.48,
          },
        ],
      },
    },
  },
  verarbeitung: {
    beilagen: [
      { gewicht: 20, unter40k: 132.9, ueber40k: 129 },
      { gewicht: 40, unter40k: 142.7, ueber40k: 138.5 },
      { gewicht: 60, unter40k: 155.9, ueber40k: 151.3 },
      { gewicht: 80, unter40k: 169.2, ueber40k: 164.2 },
      { gewicht: 100, unter40k: 192.4, ueber40k: 186.7 },
      { gewicht: 120, unter40k: 207.2, ueber40k: 201.0 },
      { gewicht: 140, unter40k: 227.1, ueber40k: 220.3 },
      { gewicht: 160, unter40k: 246.8, ueber40k: 239.4 },
      { gewicht: 180, unter40k: 266.6, ueber40k: 258.7 },
      { gewicht: 200, unter40k: 286.4, ueber40k: 277.9 },
      { gewicht: 220, unter40k: 306.2, ueber40k: 297.1 },
      { gewicht: 240, unter40k: 326, ueber40k: 316.3 },
    ],
    toc: [
      { type: "titelseite", unter40k: 180.5, ueber40k: 180.5 },
      { type: "u4", unter40k: 146.2, ueber40k: 141.9 },
    ],
    mantel: [
      { gewicht: 20, unter40k: 465, ueber40k: 451.1 },
      { gewicht: 40, unter40k: 499.5, ueber40k: 484.6 },
    ],
  },
};

const getters = {};
const mutations = {};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
